var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 368,
    viewBox: "0 0 501 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 322.775H500.525V322.525H0V322.775Z",
    fill: "#E7E8E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M417.217 338.889H450.374V338.638H417.217V338.889Z",
    fill: "#E7E8E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.865 341.604H331.567V341.354H322.865V341.604Z",
    fill: "#E7E8E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.002 329.591H416.214V329.341H397.002V329.591Z",
    fill: "#E7E8E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5144 331.024H95.7531V331.274H52.5144V331.024Z",
    fill: "#E7E8E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.666 331.024H111.006V331.274H104.666V331.024Z",
    fill: "#E7E8E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.609 335.501H225.383V335.251H131.609V335.501Z",
    fill: "#E7E8E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.352 290.808H445.887V57.0234H203.352V290.808Z",
    fill: "#DADBD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.244 286.729H445.887V61.268H207.244V286.729Z",
    fill: "#F3F2F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.006 232.125V164.311H216.051V155.355L231.905 147.939V138.77H234.547V164.311H237.188V232.125H240.712V196.897H248.637V178.403H251.28V232.125H257.445V211.87H261.848V206.584H271.536V188.09H276.82V175.76H282.985V157.266H285.628V175.76H291.793V188.09H297.077V206.584H306.764V211.87H311.168V232.125H316.452V206.584H326.14V150.22H328.782V144.055H349.92V150.22H354.323V190.733H371.937V195.136H378.102V197.778H371.937V213.631H390.431V160.788H393.955V150.22H402.762V109.708H405.404V150.22H411.569V160.788H445.887V286.729H207.244V232.125H209.006Z",
    fill: "#E2E2E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 166.046H425.054V163.55H427.549V166.046Z",
    fill: "#EDEDEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 170.229H425.054V167.733H427.549V170.229Z",
    fill: "#EDEDEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 186.963H425.054V184.468H427.549V186.963Z",
    fill: "#EDEDEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 191.146H425.054V188.651H427.549V191.146Z",
    fill: "#EDEDEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 195.329H425.054V192.833H427.549V195.329Z",
    fill: "#EDEDEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 207.88H425.054V205.384H427.549V207.88Z",
    fill: "#EDEDEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M427.549 212.063H425.054V209.568H427.549V212.063Z",
    fill: "#EDEDEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 182.778H421.09V180.283H423.585V182.778Z",
    fill: "#EDEDEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 186.963H421.09V184.468H423.585V186.963Z",
    fill: "#EDEDEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 191.146H421.09V188.651H423.585V191.146Z",
    fill: "#EDEDEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 195.329H421.09V192.833H423.585V195.329Z",
    fill: "#EDEDEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 199.514H421.09V197.018H423.585V199.514Z",
    fill: "#EDEDEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 207.88H421.09V205.384H423.585V207.88Z",
    fill: "#EDEDEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M423.585 212.063H421.09V209.568H423.585V212.063Z",
    fill: "#EDEDEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 166.046H417.127V163.55H419.623V166.046Z",
    fill: "#EDEDEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 170.229H417.127V167.733H419.623V170.229Z",
    fill: "#EDEDEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 174.413H417.127V171.918H419.623V174.413Z",
    fill: "#EDEDEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 178.597H417.127V176.101H419.623V178.597Z",
    fill: "#EDEDEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 182.778H417.127V180.283H419.623V182.778Z",
    fill: "#EDEDEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 186.963H417.127V184.468H419.623V186.963Z",
    fill: "#EDEDEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 191.146H417.127V188.651H419.623V191.146Z",
    fill: "#EDEDEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 195.329H417.127V192.833H419.623V195.329Z",
    fill: "#EDEDEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 199.514H417.127V197.018H419.623V199.514Z",
    fill: "#EDEDEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 203.696H417.127V201.202H419.623V203.696Z",
    fill: "#EDEDEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M419.623 212.063H417.127V209.568H419.623V212.063Z",
    fill: "#EDEDEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 166.046H413.164V163.55H415.66V166.046Z",
    fill: "#EDEDEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 170.229H413.164V167.733H415.66V170.229Z",
    fill: "#EDEDEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 174.413H413.164V171.918H415.66V174.413Z",
    fill: "#EDEDEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 178.597H413.164V176.101H415.66V178.597Z",
    fill: "#EDEDEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 182.778H413.164V180.283H415.66V182.778Z",
    fill: "#EDEDEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 186.963H413.164V184.468H415.66V186.963Z",
    fill: "#EDEDEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 191.146H413.164V188.651H415.66V191.146Z",
    fill: "#EDEDEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 228.797H413.164V226.301H415.66V228.797Z",
    fill: "#EDEDEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 166.046H409.201V163.55H411.697V166.046Z",
    fill: "#EDEDEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 170.229H409.201V167.733H411.697V170.229Z",
    fill: "#EDEDEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 174.413H409.201V171.918H411.697V174.413Z",
    fill: "#EDEDEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 178.597H409.201V176.101H411.697V178.597Z",
    fill: "#EDEDEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 182.778H409.201V180.283H411.697V182.778Z",
    fill: "#EDEDEB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 186.963H409.201V184.468H411.697V186.963Z",
    fill: "#EDEDEB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 191.146H409.201V188.651H411.697V191.146Z",
    fill: "#EDEDEB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 195.329H409.201V192.833H411.697V195.329Z",
    fill: "#EDEDEB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 220.43H409.201V217.934H411.697V220.43Z",
    fill: "#EDEDEB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 224.613H409.201V222.118H411.697V224.613Z",
    fill: "#EDEDEB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 228.797H409.201V226.301H411.697V228.797Z",
    fill: "#EDEDEB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 232.979H409.201V230.484H411.697V232.979Z",
    fill: "#EDEDEB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M411.697 249.713H409.201V247.218H411.697V249.713Z",
    fill: "#EDEDEB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 166.046H405.238V163.55H407.733V166.046Z",
    fill: "#EDEDEB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 170.229H405.238V167.733H407.733V170.229Z",
    fill: "#EDEDEB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 174.413H405.238V171.918H407.733V174.413Z",
    fill: "#EDEDEB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 178.597H405.238V176.101H407.733V178.597Z",
    fill: "#EDEDEB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 182.778H405.238V180.283H407.733V182.778Z",
    fill: "#EDEDEB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 186.963H405.238V184.468H407.733V186.963Z",
    fill: "#EDEDEB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 191.146H405.238V188.651H407.733V191.146Z",
    fill: "#EDEDEB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 195.329H405.238V192.833H407.733V195.329Z",
    fill: "#EDEDEB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 199.514H405.238V197.018H407.733V199.514Z",
    fill: "#EDEDEB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 203.696H405.238V201.202H407.733V203.696Z",
    fill: "#EDEDEB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 216.246H405.238V213.751H407.733V216.246Z",
    fill: "#EDEDEB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 220.43H405.238V217.934H407.733V220.43Z",
    fill: "#EDEDEB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 224.613H405.238V222.118H407.733V224.613Z",
    fill: "#EDEDEB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 228.797H405.238V226.301H407.733V228.797Z",
    fill: "#EDEDEB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 232.979H405.238V230.484H407.733V232.979Z",
    fill: "#EDEDEB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M407.733 249.713H405.238V247.218H407.733V249.713Z",
    fill: "#EDEDEB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 166.046H401.274V163.55H403.769V166.046Z",
    fill: "#EDEDEB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 170.229H401.274V167.733H403.769V170.229Z",
    fill: "#EDEDEB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 174.413H401.274V171.918H403.769V174.413Z",
    fill: "#EDEDEB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 178.597H401.274V176.101H403.769V178.597Z",
    fill: "#EDEDEB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 182.778H401.274V180.283H403.769V182.778Z",
    fill: "#EDEDEB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 186.963H401.274V184.468H403.769V186.963Z",
    fill: "#EDEDEB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 191.146H401.274V188.651H403.769V191.146Z",
    fill: "#EDEDEB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 195.329H401.274V192.833H403.769V195.329Z",
    fill: "#EDEDEB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 199.514H401.274V197.018H403.769V199.514Z",
    fill: "#EDEDEB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 203.696H401.274V201.202H403.769V203.696Z",
    fill: "#EDEDEB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 207.88H401.274V205.384H403.769V207.88Z",
    fill: "#EDEDEB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 212.063H401.274V209.568H403.769V212.063Z",
    fill: "#EDEDEB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 216.246H401.274V213.751H403.769V216.246Z",
    fill: "#EDEDEB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 220.43H401.274V217.934H403.769V220.43Z",
    fill: "#EDEDEB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 224.613H401.274V222.118H403.769V224.613Z",
    fill: "#EDEDEB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 228.797H401.274V226.301H403.769V228.797Z",
    fill: "#EDEDEB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 232.979H401.274V230.484H403.769V232.979Z",
    fill: "#EDEDEB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M403.769 237.162H401.274V234.667H403.769V237.162Z",
    fill: "#EDEDEB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 166.046H397.312V163.55H399.806V166.046Z",
    fill: "#EDEDEB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 170.229H397.312V167.733H399.806V170.229Z",
    fill: "#EDEDEB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 174.413H397.312V171.918H399.806V174.413Z",
    fill: "#EDEDEB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 178.597H397.312V176.101H399.806V178.597Z",
    fill: "#EDEDEB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 182.778H397.312V180.283H399.806V182.778Z",
    fill: "#EDEDEB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 186.963H397.312V184.468H399.806V186.963Z",
    fill: "#EDEDEB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 191.146H397.312V188.651H399.806V191.146Z",
    fill: "#EDEDEB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 195.329H397.312V192.833H399.806V195.329Z",
    fill: "#EDEDEB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 199.514H397.312V197.018H399.806V199.514Z",
    fill: "#EDEDEB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 203.696H397.312V201.202H399.806V203.696Z",
    fill: "#EDEDEB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 216.246H397.312V213.751H399.806V216.246Z",
    fill: "#EDEDEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 220.43H397.312V217.934H399.806V220.43Z",
    fill: "#EDEDEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 224.613H397.312V222.118H399.806V224.613Z",
    fill: "#EDEDEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M399.806 228.797H397.312V226.301H399.806V228.797Z",
    fill: "#EDEDEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 166.046H393.349V163.55H395.843V166.046Z",
    fill: "#EDEDEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 170.229H393.349V167.733H395.843V170.229Z",
    fill: "#EDEDEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 174.413H393.349V171.918H395.843V174.413Z",
    fill: "#EDEDEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 178.597H393.349V176.101H395.843V178.597Z",
    fill: "#EDEDEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 182.778H393.349V180.283H395.843V182.778Z",
    fill: "#EDEDEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 186.963H393.349V184.468H395.843V186.963Z",
    fill: "#EDEDEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 191.146H393.349V188.651H395.843V191.146Z",
    fill: "#EDEDEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 195.329H393.349V192.833H395.843V195.329Z",
    fill: "#EDEDEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 199.514H393.349V197.018H395.843V199.514Z",
    fill: "#EDEDEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 203.696H393.349V201.202H395.843V203.696Z",
    fill: "#EDEDEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 216.246H393.349V213.751H395.843V216.246Z",
    fill: "#EDEDEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 220.43H393.349V217.934H395.843V220.43Z",
    fill: "#EDEDEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M395.843 224.613H393.349V222.118H395.843V224.613Z",
    fill: "#EDEDEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 155.184H348.725V152.689H351.221V155.184Z",
    fill: "#EDEDEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 159.368H348.725V156.873H351.221V159.368Z",
    fill: "#EDEDEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 163.55H348.725V161.055H351.221V163.55Z",
    fill: "#EDEDEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 167.733H348.725V165.239H351.221V167.733Z",
    fill: "#EDEDEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 171.918H348.725V169.422H351.221V171.918Z",
    fill: "#EDEDEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 176.101H348.725V173.606H351.221V176.101Z",
    fill: "#EDEDEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 180.284H348.725V177.79H351.221V180.284Z",
    fill: "#EDEDEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 184.468H348.725V181.972H351.221V184.468Z",
    fill: "#EDEDEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 197.017H348.725V194.522H351.221V197.017Z",
    fill: "#EDEDEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M351.221 201.202H348.725V198.706H351.221V201.202Z",
    fill: "#EDEDEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M347.259 155.184H344.762V152.689H347.259V155.184Z",
    fill: "#EDEDEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M347.259 159.368H344.762V156.873H347.259V159.368Z",
    fill: "#EDEDEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M344.762 163.55H347.258V161.055H344.762V163.55Z",
    fill: "#EDEDEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M344.762 167.733H347.258V165.239H344.762V167.733Z",
    fill: "#EDEDEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M344.762 171.918H347.258V169.422H344.762V171.918Z",
    fill: "#EDEDEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M344.762 176.101H347.258V173.606H344.762V176.101Z",
    fill: "#EDEDEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M347.259 180.284H344.762V177.79H347.259V180.284Z",
    fill: "#EDEDEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M347.259 184.468H344.762V181.972H347.259V184.468Z",
    fill: "#EDEDEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M347.259 201.202H344.762V198.706H347.259V201.202Z",
    fill: "#EDEDEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M343.294 155.184H340.798V152.689H343.294V155.184Z",
    fill: "#EDEDEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M343.294 159.368H340.798V156.873H343.294V159.368Z",
    fill: "#EDEDEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 163.55H343.295V161.055H340.798V163.55Z",
    fill: "#EDEDEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 167.733H343.295V165.239H340.798V167.733Z",
    fill: "#EDEDEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 171.918H343.295V169.422H340.798V171.918Z",
    fill: "#EDEDEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 176.101H343.295V173.606H340.798V176.101Z",
    fill: "#EDEDEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 180.284H343.295V177.79H340.798V180.284Z",
    fill: "#EDEDEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M340.798 184.468H343.295V181.972H340.798V184.468Z",
    fill: "#EDEDEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M339.332 155.184H336.835V152.689H339.332V155.184Z",
    fill: "#EDEDEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M339.332 159.368H336.835V156.873H339.332V159.368Z",
    fill: "#EDEDEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 163.55H339.332V161.055H336.835V163.55Z",
    fill: "#EDEDEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 167.733H339.332V165.239H336.835V167.733Z",
    fill: "#EDEDEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 171.918H339.332V169.422H336.835V171.918Z",
    fill: "#EDEDEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 176.101H339.332V173.606H336.835V176.101Z",
    fill: "#EDEDEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 184.468H339.332V181.972H336.835V184.468Z",
    fill: "#EDEDEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 188.65H339.332V186.155H336.835V188.65Z",
    fill: "#EDEDEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M339.332 201.202H336.835V198.706H339.332V201.202Z",
    fill: "#EDEDEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M339.332 205.385H336.835V202.889H339.332V205.385Z",
    fill: "#EDEDEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 209.568H339.332V207.074H336.835V209.568Z",
    fill: "#EDEDEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 213.752H339.332V211.255H336.835V213.752Z",
    fill: "#EDEDEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 217.935H339.332V215.439H336.835V217.935Z",
    fill: "#EDEDEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 222.118H339.332V219.622H336.835V222.118Z",
    fill: "#EDEDEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M336.835 226.301H339.332V223.806H336.835V226.301Z",
    fill: "#EDEDEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 155.184H332.872V152.689H335.369V155.184Z",
    fill: "#EDEDEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 159.368H332.872V156.873H335.369V159.368Z",
    fill: "#EDEDEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 163.55H335.369V161.055H332.872V163.55Z",
    fill: "#EDEDEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 167.733H335.369V165.239H332.872V167.733Z",
    fill: "#EDEDEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 171.918H335.369V169.422H332.872V171.918Z",
    fill: "#EDEDEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 176.101H335.369V173.606H332.872V176.101Z",
    fill: "#EDEDEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 188.65H335.369V186.155H332.872V188.65Z",
    fill: "#EDEDEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 192.835H332.872V190.34H335.369V192.835Z",
    fill: "#EDEDEB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 197.017H332.872V194.522H335.369V197.017Z",
    fill: "#EDEDEB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 201.202H332.872V198.706H335.369V201.202Z",
    fill: "#EDEDEB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M335.369 205.385H332.872V202.889H335.369V205.385Z",
    fill: "#EDEDEB"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 209.568H335.369V207.074H332.872V209.568Z",
    fill: "#EDEDEB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 213.752H335.369V211.255H332.872V213.752Z",
    fill: "#EDEDEB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 217.935H335.369V215.439H332.872V217.935Z",
    fill: "#EDEDEB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 222.118H335.369V219.622H332.872V222.118Z",
    fill: "#EDEDEB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 226.301H335.369V223.806H332.872V226.301Z",
    fill: "#EDEDEB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 230.484H335.369V227.989H332.872V230.484Z",
    fill: "#EDEDEB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M332.872 238.852H335.369V236.357H332.872V238.852Z",
    fill: "#EDEDEB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 155.184H331.405V152.689H328.911V155.184Z",
    fill: "#EDEDEB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 159.368H331.405V156.872H328.911V159.368Z",
    fill: "#EDEDEB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 163.55H331.405V161.055H328.911V163.55Z",
    fill: "#EDEDEB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 167.733H331.405V165.239H328.911V167.733Z",
    fill: "#EDEDEB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 171.918H331.405V169.422H328.911V171.918Z",
    fill: "#EDEDEB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 176.101H331.405V173.606H328.911V176.101Z",
    fill: "#EDEDEB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 188.65H331.405V186.155H328.911V188.65Z",
    fill: "#EDEDEB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 192.835H331.405V190.34H328.911V192.835Z",
    fill: "#EDEDEB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M331.404 197.017H328.908V194.522H331.404V197.017Z",
    fill: "#EDEDEB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M331.404 201.202H328.908V198.706H331.404V201.202Z",
    fill: "#EDEDEB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 213.752H331.405V211.255H328.911V213.752Z",
    fill: "#EDEDEB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 217.935H331.405V215.439H328.911V217.935Z",
    fill: "#EDEDEB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 222.118H331.405V219.622H328.911V222.118Z",
    fill: "#EDEDEB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 226.301H331.405V223.806H328.911V226.301Z",
    fill: "#EDEDEB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 230.484H331.405V227.989H328.911V230.484Z",
    fill: "#EDEDEB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 238.852H331.405V236.357H328.911V238.852Z",
    fill: "#EDEDEB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M328.911 243.034H331.405V240.539H328.911V243.034Z",
    fill: "#EDEDEB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 194.082H295.443V191.587H292.948V194.082Z",
    fill: "#EDEDEB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 198.265H295.443V195.769H292.948V198.265Z",
    fill: "#EDEDEB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 202.449H295.443V199.952H292.948V202.449Z",
    fill: "#EDEDEB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 206.632H295.443V204.137H292.948V206.632Z",
    fill: "#EDEDEB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M295.443 210.816H292.948V208.321H295.443V210.816Z",
    fill: "#EDEDEB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M295.443 214.999H292.948V212.503H295.443V214.999Z",
    fill: "#EDEDEB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M295.443 219.182H292.948V216.687H295.443V219.182Z",
    fill: "#EDEDEB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 231.732H295.443V229.236H292.948V231.732Z",
    fill: "#EDEDEB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 235.915H295.443V233.421H292.948V235.915Z",
    fill: "#EDEDEB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M292.948 240.099H295.443V237.604H292.948V240.099Z",
    fill: "#EDEDEB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M288.985 194.082H291.481V191.587H288.985V194.082Z",
    fill: "#EDEDEB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M288.985 198.265H291.481V195.769H288.985V198.265Z",
    fill: "#EDEDEB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M288.985 202.449H291.481V199.952H288.985V202.449Z",
    fill: "#EDEDEB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M288.985 206.632H291.481V204.137H288.985V206.632Z",
    fill: "#EDEDEB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M291.48 210.816H288.985V208.321H291.48V210.816Z",
    fill: "#EDEDEB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M291.48 214.999H288.985V212.503H291.48V214.999Z",
    fill: "#EDEDEB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M291.48 219.182H288.985V216.687H291.48V219.182Z",
    fill: "#EDEDEB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M285.021 194.082H287.516V191.587H285.021V194.082Z",
    fill: "#EDEDEB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M285.021 198.265H287.516V195.769H285.021V198.265Z",
    fill: "#EDEDEB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M285.021 202.449H287.516V199.952H285.021V202.449Z",
    fill: "#EDEDEB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M285.021 206.632H287.516V204.137H285.021V206.632Z",
    fill: "#EDEDEB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M287.516 210.816H285.021V208.321H287.516V210.816Z",
    fill: "#EDEDEB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M287.516 214.999H285.021V212.503H287.516V214.999Z",
    fill: "#EDEDEB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M287.516 219.182H285.021V216.687H287.516V219.182Z",
    fill: "#EDEDEB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 194.082H283.552V191.587H281.058V194.082Z",
    fill: "#EDEDEB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 198.265H283.552V195.769H281.058V198.265Z",
    fill: "#EDEDEB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 202.449H283.552V199.952H281.058V202.449Z",
    fill: "#EDEDEB"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 206.632H283.552V204.137H281.058V206.632Z",
    fill: "#EDEDEB"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M283.552 210.816H281.058V208.321H283.552V210.816Z",
    fill: "#EDEDEB"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M283.552 214.999H281.058V212.503H283.552V214.999Z",
    fill: "#EDEDEB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M283.552 219.182H281.058V216.687H283.552V219.182Z",
    fill: "#EDEDEB"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 223.365H283.552V220.871H281.058V223.365Z",
    fill: "#EDEDEB"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 227.55H283.552V225.054H281.058V227.55Z",
    fill: "#EDEDEB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 231.732H283.552V229.236H281.058V231.732Z",
    fill: "#EDEDEB"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M281.058 235.915H283.552V233.421H281.058V235.915Z",
    fill: "#EDEDEB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 194.082H277.095V191.587H279.589V194.082Z",
    fill: "#EDEDEB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 198.265H279.59V195.769H277.095V198.265Z",
    fill: "#EDEDEB"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 202.449H279.59V199.952H277.095V202.449Z",
    fill: "#EDEDEB"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 206.632H279.59V204.137H277.095V206.632Z",
    fill: "#EDEDEB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 210.816H277.095V208.321H279.589V210.816Z",
    fill: "#EDEDEB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 214.999H277.095V212.503H279.589V214.999Z",
    fill: "#EDEDEB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M279.589 219.182H277.095V216.687H279.589V219.182Z",
    fill: "#EDEDEB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 223.365H279.59V220.871H277.095V223.365Z",
    fill: "#EDEDEB"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 227.55H279.59V225.054H277.095V227.55Z",
    fill: "#EDEDEB"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 231.732H279.59V229.236H277.095V231.732Z",
    fill: "#EDEDEB"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 235.915H279.59V233.421H277.095V235.915Z",
    fill: "#EDEDEB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 240.099H279.59V237.604H277.095V240.099Z",
    fill: "#EDEDEB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 252.648H279.59V250.154H277.095V252.648Z",
    fill: "#EDEDEB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M277.095 256.832H279.59V254.338H277.095V256.832Z",
    fill: "#EDEDEB"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 194.082H275.626V191.587H273.131V194.082Z",
    fill: "#EDEDEB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 198.265H275.626V195.769H273.131V198.265Z",
    fill: "#EDEDEB"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 202.449H275.626V199.952H273.131V202.449Z",
    fill: "#EDEDEB"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M275.625 214.999H273.131V212.503H275.625V214.999Z",
    fill: "#EDEDEB"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M275.625 219.182H273.131V216.687H275.625V219.182Z",
    fill: "#EDEDEB"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 223.365H275.626V220.871H273.131V223.365Z",
    fill: "#EDEDEB"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 227.55H275.626V225.054H273.131V227.55Z",
    fill: "#EDEDEB"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 231.732H275.626V229.236H273.131V231.732Z",
    fill: "#EDEDEB"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 235.915H275.626V233.421H273.131V235.915Z",
    fill: "#EDEDEB"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 240.099H275.626V237.604H273.131V240.099Z",
    fill: "#EDEDEB"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 252.648H275.626V250.154H273.131V252.648Z",
    fill: "#EDEDEB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 256.832H275.626V254.338H273.131V256.832Z",
    fill: "#EDEDEB"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M273.131 261.016H275.626V258.519H273.131V261.016Z",
    fill: "#EDEDEB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 168.981H234.086V166.486H231.59V168.981Z",
    fill: "#EDEDEB"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 173.165H234.086V170.669H231.59V173.165Z",
    fill: "#EDEDEB"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 177.348H234.086V174.853H231.59V177.348Z",
    fill: "#EDEDEB"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 181.531H234.086V179.036H231.59V181.531Z",
    fill: "#EDEDEB"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 185.715H231.59V183.219H234.086V185.715Z",
    fill: "#EDEDEB"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 189.899H231.59V187.404H234.086V189.899Z",
    fill: "#EDEDEB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 194.082H234.086V191.587H231.59V194.082Z",
    fill: "#EDEDEB"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 198.265H234.086V195.769H231.59V198.265Z",
    fill: "#EDEDEB"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 202.449H234.086V199.952H231.59V202.449Z",
    fill: "#EDEDEB"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M231.59 206.632H234.086V204.137H231.59V206.632Z",
    fill: "#EDEDEB"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 210.816H231.59V208.321H234.086V210.816Z",
    fill: "#EDEDEB"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 214.999H231.59V212.503H234.086V214.999Z",
    fill: "#EDEDEB"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 219.182H231.59V216.687H234.086V219.182Z",
    fill: "#EDEDEB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 223.365H231.59V220.871H234.086V223.365Z",
    fill: "#EDEDEB"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 227.55H231.59V225.054H234.086V227.55Z",
    fill: "#EDEDEB"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 231.732H231.59V229.236H234.086V231.732Z",
    fill: "#EDEDEB"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 235.915H231.59V233.42H234.086V235.915Z",
    fill: "#EDEDEB"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 240.099H231.59V237.604H234.086V240.099Z",
    fill: "#EDEDEB"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 244.283H231.59V241.788H234.086V244.283Z",
    fill: "#EDEDEB"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 248.465H231.59V245.969H234.086V248.465Z",
    fill: "#EDEDEB"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 252.648H231.59V250.154H234.086V252.648Z",
    fill: "#EDEDEB"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 256.832H231.59V254.337H234.086V256.832Z",
    fill: "#EDEDEB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M234.086 261.016H231.59V258.52H234.086V261.016Z",
    fill: "#EDEDEB"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 168.981H230.123V166.486H227.627V168.981Z",
    fill: "#EDEDEB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 173.165H230.123V170.669H227.627V173.165Z",
    fill: "#EDEDEB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 177.348H230.123V174.853H227.627V177.348Z",
    fill: "#EDEDEB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 181.531H230.123V179.036H227.627V181.531Z",
    fill: "#EDEDEB"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 185.715H227.627V183.219H230.123V185.715Z",
    fill: "#EDEDEB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 189.899H227.627V187.404H230.123V189.899Z",
    fill: "#EDEDEB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 194.082H230.123V191.587H227.627V194.082Z",
    fill: "#EDEDEB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 198.265H230.123V195.769H227.627V198.265Z",
    fill: "#EDEDEB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 202.449H230.123V199.952H227.627V202.449Z",
    fill: "#EDEDEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 206.632H230.123V204.137H227.627V206.632Z",
    fill: "#EDEDEB"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 210.816H227.627V208.321H230.123V210.816Z",
    fill: "#EDEDEB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 214.999H227.627V212.503H230.123V214.999Z",
    fill: "#EDEDEB"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 219.182H227.627V216.687H230.123V219.182Z",
    fill: "#EDEDEB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 223.365H227.627V220.871H230.123V223.365Z",
    fill: "#EDEDEB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 227.55H227.627V225.054H230.123V227.55Z",
    fill: "#EDEDEB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 231.732H227.627V229.236H230.123V231.732Z",
    fill: "#EDEDEB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 235.915H227.627V233.42H230.123V235.915Z",
    fill: "#EDEDEB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 240.099H227.627V237.604H230.123V240.099Z",
    fill: "#EDEDEB"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M230.123 244.283H227.627V241.788H230.123V244.283Z",
    fill: "#EDEDEB"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 168.981H226.16V166.486H223.665V168.981Z",
    fill: "#EDEDEB"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 173.165H226.16V170.669H223.665V173.165Z",
    fill: "#EDEDEB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 177.348H226.16V174.853H223.665V177.348Z",
    fill: "#EDEDEB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 181.531H226.16V179.036H223.665V181.531Z",
    fill: "#EDEDEB"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 185.715H223.665V183.219H226.16V185.715Z",
    fill: "#EDEDEB"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 189.899H223.665V187.404H226.16V189.899Z",
    fill: "#EDEDEB"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 194.082H226.16V191.587H223.665V194.082Z",
    fill: "#EDEDEB"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 198.265H226.16V195.769H223.665V198.265Z",
    fill: "#EDEDEB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 202.449H226.16V199.952H223.665V202.449Z",
    fill: "#EDEDEB"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M223.665 206.632H226.16V204.137H223.665V206.632Z",
    fill: "#EDEDEB"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 210.816H223.665V208.321H226.16V210.816Z",
    fill: "#EDEDEB"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 214.999H223.665V212.503H226.16V214.999Z",
    fill: "#EDEDEB"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 219.182H223.665V216.687H226.16V219.182Z",
    fill: "#EDEDEB"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 223.365H223.665V220.871H226.16V223.365Z",
    fill: "#EDEDEB"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 227.55H223.665V225.054H226.16V227.55Z",
    fill: "#EDEDEB"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 231.732H223.665V229.236H226.16V231.732Z",
    fill: "#EDEDEB"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 235.915H223.665V233.42H226.16V235.915Z",
    fill: "#EDEDEB"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 240.099H223.665V237.604H226.16V240.099Z",
    fill: "#EDEDEB"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16 244.283H223.665V241.788H226.16V244.283Z",
    fill: "#EDEDEB"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 168.981H222.197V166.486H219.702V168.981Z",
    fill: "#EDEDEB"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 173.165H222.197V170.669H219.702V173.165Z",
    fill: "#EDEDEB"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 177.348H222.197V174.853H219.702V177.348Z",
    fill: "#EDEDEB"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 181.531H222.197V179.036H219.702V181.531Z",
    fill: "#EDEDEB"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 185.715H219.702V183.219H222.198V185.715Z",
    fill: "#EDEDEB"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 189.899H219.702V187.404H222.198V189.899Z",
    fill: "#EDEDEB"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 194.082H222.197V191.587H219.702V194.082Z",
    fill: "#EDEDEB"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 198.265H222.197V195.769H219.702V198.265Z",
    fill: "#EDEDEB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 202.449H222.197V199.952H219.702V202.449Z",
    fill: "#EDEDEB"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M219.702 206.632H222.197V204.137H219.702V206.632Z",
    fill: "#EDEDEB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 210.816H219.702V208.321H222.198V210.816Z",
    fill: "#EDEDEB"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 214.999H219.702V212.503H222.198V214.999Z",
    fill: "#EDEDEB"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 219.182H219.702V216.687H222.198V219.182Z",
    fill: "#EDEDEB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 223.365H219.702V220.871H222.198V223.365Z",
    fill: "#EDEDEB"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M222.198 227.55H219.702V225.054H222.198V227.55Z",
    fill: "#EDEDEB"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 168.981H218.235V166.486H215.739V168.981Z",
    fill: "#EDEDEB"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 173.165H218.235V170.669H215.739V173.165Z",
    fill: "#EDEDEB"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 177.348H218.235V174.853H215.739V177.348Z",
    fill: "#EDEDEB"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 181.531H218.235V179.036H215.739V181.531Z",
    fill: "#EDEDEB"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M218.235 185.715H215.739V183.219H218.235V185.715Z",
    fill: "#EDEDEB"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M218.235 189.899H215.739V187.404H218.235V189.899Z",
    fill: "#EDEDEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 194.082H218.235V191.587H215.739V194.082Z",
    fill: "#EDEDEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 198.265H218.235V195.769H215.739V198.265Z",
    fill: "#EDEDEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 202.449H218.235V199.952H215.739V202.449Z",
    fill: "#EDEDEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M215.739 206.632H218.235V204.137H215.739V206.632Z",
    fill: "#EDEDEB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M218.235 210.816H215.739V208.321H218.235V210.816Z",
    fill: "#EDEDEB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M218.235 214.999H215.739V212.503H218.235V214.999Z",
    fill: "#EDEDEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M218.235 219.182H215.739V216.687H218.235V219.182Z",
    fill: "#EDEDEB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 168.981H214.27V166.486H211.775V168.981Z",
    fill: "#EDEDEB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 173.165H214.27V170.669H211.775V173.165Z",
    fill: "#EDEDEB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 177.348H214.27V174.853H211.775V177.348Z",
    fill: "#EDEDEB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 181.531H214.27V179.036H211.775V181.531Z",
    fill: "#EDEDEB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 185.715H211.775V183.219H214.271V185.715Z",
    fill: "#EDEDEB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 189.899H211.775V187.404H214.271V189.899Z",
    fill: "#EDEDEB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 194.082H214.27V191.587H211.775V194.082Z",
    fill: "#EDEDEB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 198.265H214.27V195.769H211.775V198.265Z",
    fill: "#EDEDEB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 202.449H214.27V199.952H211.775V202.449Z",
    fill: "#EDEDEB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 206.632H214.27V204.137H211.775V206.632Z",
    fill: "#EDEDEB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 210.816H211.775V208.321H214.271V210.816Z",
    fill: "#EDEDEB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 214.999H211.775V212.503H214.271V214.999Z",
    fill: "#EDEDEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 167.733H443.107V165.239H445.603V167.733Z",
    fill: "#EDEDEB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 171.918H443.107V169.422H445.603V171.918Z",
    fill: "#EDEDEB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 176.101H443.107V173.606H445.603V176.101Z",
    fill: "#EDEDEB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 180.284H443.107V177.79H445.603V180.284Z",
    fill: "#EDEDEB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 184.468H443.107V181.972H445.603V184.468Z",
    fill: "#EDEDEB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 188.65H443.107V186.155H445.603V188.65Z",
    fill: "#EDEDEB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 192.835H443.107V190.34H445.603V192.835Z",
    fill: "#EDEDEB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 197.017H443.107V194.522H445.603V197.017Z",
    fill: "#EDEDEB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 201.202H443.107V198.706H445.603V201.202Z",
    fill: "#EDEDEB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 205.385H443.107V202.889H445.603V205.385Z",
    fill: "#EDEDEB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 209.568H443.107V207.074H445.603V209.568Z",
    fill: "#EDEDEB"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 213.752H443.107V211.255H445.603V213.752Z",
    fill: "#EDEDEB"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 217.935H443.107V215.439H445.603V217.935Z",
    fill: "#EDEDEB"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 222.118H443.107V219.623H445.603V222.118Z",
    fill: "#EDEDEB"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 226.301H443.107V223.806H445.603V226.301Z",
    fill: "#EDEDEB"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 230.484H443.107V227.989H445.603V230.484Z",
    fill: "#EDEDEB"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 234.668H443.107V232.172H445.603V234.668Z",
    fill: "#EDEDEB"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 243.034H443.107V240.539H445.603V243.034Z",
    fill: "#EDEDEB"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 247.218H443.107V244.722H445.603V247.218Z",
    fill: "#EDEDEB"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 251.401H443.107V248.906H445.603V251.401Z",
    fill: "#EDEDEB"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 255.585H443.107V253.09H445.603V255.585Z",
    fill: "#EDEDEB"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M445.603 259.767H443.107V257.272H445.603V259.767Z",
    fill: "#EDEDEB"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 167.733H439.145V165.239H441.64V167.733Z",
    fill: "#EDEDEB"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 171.918H439.145V169.422H441.64V171.918Z",
    fill: "#EDEDEB"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 176.101H439.145V173.606H441.64V176.101Z",
    fill: "#EDEDEB"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 180.284H439.145V177.79H441.64V180.284Z",
    fill: "#EDEDEB"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 184.468H439.145V181.972H441.64V184.468Z",
    fill: "#EDEDEB"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 188.65H439.145V186.155H441.64V188.65Z",
    fill: "#EDEDEB"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 192.835H439.145V190.34H441.64V192.835Z",
    fill: "#EDEDEB"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 197.017H439.145V194.522H441.64V197.017Z",
    fill: "#EDEDEB"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 201.202H439.145V198.706H441.64V201.202Z",
    fill: "#EDEDEB"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 205.385H439.145V202.889H441.64V205.385Z",
    fill: "#EDEDEB"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 209.568H439.145V207.074H441.64V209.568Z",
    fill: "#EDEDEB"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 213.752H439.145V211.255H441.64V213.752Z",
    fill: "#EDEDEB"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 217.935H439.145V215.439H441.64V217.935Z",
    fill: "#EDEDEB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 222.118H439.145V219.623H441.64V222.118Z",
    fill: "#EDEDEB"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 226.301H439.145V223.806H441.64V226.301Z",
    fill: "#EDEDEB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 230.484H439.145V227.989H441.64V230.484Z",
    fill: "#EDEDEB"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 255.585H439.145V253.09H441.64V255.585Z",
    fill: "#EDEDEB"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 259.767H439.145V257.272H441.64V259.767Z",
    fill: "#EDEDEB"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 167.733H435.181V165.239H437.676V167.733Z",
    fill: "#EDEDEB"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 171.918H435.181V169.422H437.676V171.918Z",
    fill: "#EDEDEB"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 176.101H435.181V173.606H437.676V176.101Z",
    fill: "#EDEDEB"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 180.284H435.181V177.79H437.676V180.284Z",
    fill: "#EDEDEB"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 184.468H435.181V181.972H437.676V184.468Z",
    fill: "#EDEDEB"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 188.65H435.181V186.155H437.676V188.65Z",
    fill: "#EDEDEB"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 192.835H435.181V190.34H437.676V192.835Z",
    fill: "#EDEDEB"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 197.017H435.181V194.522H437.676V197.017Z",
    fill: "#EDEDEB"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 201.202H435.181V198.706H437.676V201.202Z",
    fill: "#EDEDEB"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 205.385H435.181V202.889H437.676V205.385Z",
    fill: "#EDEDEB"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 209.568H435.181V207.074H437.676V209.568Z",
    fill: "#EDEDEB"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 213.752H435.181V211.255H437.676V213.752Z",
    fill: "#EDEDEB"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 217.935H435.181V215.439H437.676V217.935Z",
    fill: "#EDEDEB"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 222.118H435.181V219.623H437.676V222.118Z",
    fill: "#EDEDEB"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 226.301H435.181V223.806H437.676V226.301Z",
    fill: "#EDEDEB"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 230.484H435.181V227.989H437.676V230.484Z",
    fill: "#EDEDEB"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 238.852H435.181V236.357H437.676V238.852Z",
    fill: "#EDEDEB"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 243.034H435.181V240.539H437.676V243.034Z",
    fill: "#EDEDEB"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 247.218H435.181V244.722H437.676V247.218Z",
    fill: "#EDEDEB"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 251.401H435.181V248.906H437.676V251.401Z",
    fill: "#EDEDEB"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M437.676 259.767H435.181V257.272H437.676V259.767Z",
    fill: "#EDEDEB"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M368.542 197.017H366.046V194.522H368.542V197.017Z",
    fill: "#EDEDEB"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 201.2H368.541V198.705H366.046V201.2Z",
    fill: "#EDEDEB"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 205.385H368.541V202.889H366.046V205.385Z",
    fill: "#EDEDEB"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 209.568H368.541V207.074H366.046V209.568Z",
    fill: "#EDEDEB"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 213.752H368.541V211.255H366.046V213.752Z",
    fill: "#EDEDEB"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 217.935H368.541V215.439H366.046V217.935Z",
    fill: "#EDEDEB"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 222.118H368.541V219.622H366.046V222.118Z",
    fill: "#EDEDEB"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 226.301H368.541V223.806H366.046V226.301Z",
    fill: "#EDEDEB"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 230.484H368.541V227.989H366.046V230.484Z",
    fill: "#EDEDEB"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 234.668H368.541V232.172H366.046V234.668Z",
    fill: "#EDEDEB"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 238.852H368.541V236.357H366.046V238.852Z",
    fill: "#EDEDEB"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 243.034H368.541V240.539H366.046V243.034Z",
    fill: "#EDEDEB"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 247.218H368.541V244.722H366.046V247.218Z",
    fill: "#EDEDEB"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 255.585H368.541V253.091H366.046V255.585Z",
    fill: "#EDEDEB"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M368.542 259.767H366.046V257.272H368.542V259.767Z",
    fill: "#EDEDEB"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 263.951H368.541V261.456H366.046V263.951Z",
    fill: "#EDEDEB"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M366.046 268.135H368.541V265.64H366.046V268.135Z",
    fill: "#EDEDEB"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M368.542 276.501H366.046V274.005H368.542V276.501Z",
    fill: "#EDEDEB"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M368.542 280.685H366.046V278.189H368.542V280.685Z",
    fill: "#EDEDEB"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M368.542 284.869H366.046V282.374H368.542V284.869Z",
    fill: "#EDEDEB"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M364.579 197.017H362.083V194.522H364.579V197.017Z",
    fill: "#EDEDEB"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 201.2H364.579V198.705H362.083V201.2Z",
    fill: "#EDEDEB"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 205.385H364.579V202.889H362.083V205.385Z",
    fill: "#EDEDEB"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 209.568H364.579V207.074H362.083V209.568Z",
    fill: "#EDEDEB"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 213.752H364.579V211.255H362.083V213.752Z",
    fill: "#EDEDEB"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 217.935H364.579V215.439H362.083V217.935Z",
    fill: "#EDEDEB"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 222.118H364.579V219.622H362.083V222.118Z",
    fill: "#EDEDEB"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 226.301H364.579V223.806H362.083V226.301Z",
    fill: "#EDEDEB"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 230.484H364.579V227.989H362.083V230.484Z",
    fill: "#EDEDEB"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 234.668H364.579V232.172H362.083V234.668Z",
    fill: "#EDEDEB"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 238.852H364.579V236.357H362.083V238.852Z",
    fill: "#EDEDEB"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 243.034H364.579V240.539H362.083V243.034Z",
    fill: "#EDEDEB"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 247.218H364.579V244.722H362.083V247.218Z",
    fill: "#EDEDEB"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 259.767H364.579V257.272H362.083V259.767Z",
    fill: "#EDEDEB"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M362.083 263.951H364.579V261.456H362.083V263.951Z",
    fill: "#EDEDEB"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M364.579 272.317H362.083V269.822H364.579V272.317Z",
    fill: "#EDEDEB"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M364.579 276.501H362.083V274.005H364.579V276.501Z",
    fill: "#EDEDEB"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M364.579 280.685H362.083V278.189H364.579V280.685Z",
    fill: "#EDEDEB"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M364.579 284.869H362.083V282.374H364.579V284.869Z",
    fill: "#EDEDEB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M360.616 197.017H358.12V194.522H360.616V197.017Z",
    fill: "#EDEDEB"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 201.2H360.616V198.705H358.12V201.2Z",
    fill: "#EDEDEB"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 205.385H360.616V202.889H358.12V205.385Z",
    fill: "#EDEDEB"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 209.568H360.616V207.074H358.12V209.568Z",
    fill: "#EDEDEB"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 213.752H360.616V211.255H358.12V213.752Z",
    fill: "#EDEDEB"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 217.935H360.616V215.439H358.12V217.935Z",
    fill: "#EDEDEB"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 222.118H360.616V219.622H358.12V222.118Z",
    fill: "#EDEDEB"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 226.301H360.616V223.806H358.12V226.301Z",
    fill: "#EDEDEB"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 230.484H360.616V227.989H358.12V230.484Z",
    fill: "#EDEDEB"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 234.668H360.616V232.172H358.12V234.668Z",
    fill: "#EDEDEB"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 238.852H360.616V236.357H358.12V238.852Z",
    fill: "#EDEDEB"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 243.034H360.616V240.539H358.12V243.034Z",
    fill: "#EDEDEB"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 247.218H360.616V244.722H358.12V247.218Z",
    fill: "#EDEDEB"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 251.401H360.616V248.906H358.12V251.401Z",
    fill: "#EDEDEB"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 259.767H360.616V257.272H358.12V259.767Z",
    fill: "#EDEDEB"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M358.12 268.135H360.616V265.64H358.12V268.135Z",
    fill: "#EDEDEB"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M360.616 272.317H358.12V269.822H360.616V272.317Z",
    fill: "#EDEDEB"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M360.616 276.501H358.12V274.005H360.616V276.501Z",
    fill: "#EDEDEB"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M360.616 280.685H358.12V278.189H360.616V280.685Z",
    fill: "#EDEDEB"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M360.616 284.869H358.12V282.374H360.616V284.869Z",
    fill: "#EDEDEB"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 220.871H382.192V218.375H384.687V220.871Z",
    fill: "#EDEDEB"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 225.053H382.192V222.558H384.687V225.053Z",
    fill: "#EDEDEB"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 229.236H382.192V226.742H384.687V229.236Z",
    fill: "#EDEDEB"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 233.421H382.192V230.925H384.687V233.421Z",
    fill: "#EDEDEB"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 237.604H382.192V235.109H384.687V237.604Z",
    fill: "#EDEDEB"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 241.787H382.192V239.291H384.687V241.787Z",
    fill: "#EDEDEB"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 254.338H382.192V251.842H384.687V254.338Z",
    fill: "#EDEDEB"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 258.52H382.192V256.025H384.687V258.52Z",
    fill: "#EDEDEB"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 262.704H382.192V260.208H384.687V262.704Z",
    fill: "#EDEDEB"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 266.888H382.192V264.392H384.687V266.888Z",
    fill: "#EDEDEB"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 271.069H382.192V268.575H384.687V271.069Z",
    fill: "#EDEDEB"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 275.253H382.192V272.759H384.687V275.253Z",
    fill: "#EDEDEB"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687 279.438H382.192V276.942H384.687V279.438Z",
    fill: "#EDEDEB"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 220.871H378.229V218.375H380.724V220.871Z",
    fill: "#EDEDEB"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 225.053H378.229V222.558H380.724V225.053Z",
    fill: "#EDEDEB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 229.236H378.229V226.742H380.724V229.236Z",
    fill: "#EDEDEB"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 233.421H378.229V230.925H380.724V233.421Z",
    fill: "#EDEDEB"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 237.604H378.229V235.109H380.724V237.604Z",
    fill: "#EDEDEB"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 241.787H378.229V239.291H380.724V241.787Z",
    fill: "#EDEDEB"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 254.338H378.229V251.842H380.724V254.338Z",
    fill: "#EDEDEB"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 258.52H378.229V256.025H380.724V258.52Z",
    fill: "#EDEDEB"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 262.704H378.229V260.208H380.724V262.704Z",
    fill: "#EDEDEB"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 266.888H378.229V264.392H380.724V266.888Z",
    fill: "#EDEDEB"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 271.069H378.229V268.575H380.724V271.069Z",
    fill: "#EDEDEB"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 275.253H378.229V272.759H380.724V275.253Z",
    fill: "#EDEDEB"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M380.724 283.621H378.229V281.125H380.724V283.621Z",
    fill: "#EDEDEB"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 202.449H249.058V199.952H246.563V202.449Z",
    fill: "#EDEDEB"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 206.632H249.058V204.137H246.563V206.632Z",
    fill: "#EDEDEB"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 210.816H249.058V208.321H246.563V210.816Z",
    fill: "#EDEDEB"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 214.999H249.058V212.503H246.563V214.999Z",
    fill: "#EDEDEB"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 219.182H249.058V216.687H246.563V219.182Z",
    fill: "#EDEDEB"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 223.365H249.058V220.871H246.563V223.365Z",
    fill: "#EDEDEB"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 227.55H249.058V225.054H246.563V227.55Z",
    fill: "#EDEDEB"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 231.732H249.058V229.236H246.563V231.732Z",
    fill: "#EDEDEB"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 235.915H249.058V233.421H246.563V235.915Z",
    fill: "#EDEDEB"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 240.099H249.058V237.604H246.563V240.099Z",
    fill: "#EDEDEB"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 244.283H249.058V241.786H246.563V244.283Z",
    fill: "#EDEDEB"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 252.648H249.058V250.154H246.563V252.648Z",
    fill: "#EDEDEB"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 256.832H249.058V254.338H246.563V256.832Z",
    fill: "#EDEDEB"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 261.016H249.058V258.519H246.563V261.016Z",
    fill: "#EDEDEB"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 265.198H249.058V262.703H246.563V265.198Z",
    fill: "#EDEDEB"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 269.382H249.058V266.887H246.563V269.382Z",
    fill: "#EDEDEB"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 273.566H249.058V271.07H246.563V273.566Z",
    fill: "#EDEDEB"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 277.748H249.058V275.252H246.563V277.748Z",
    fill: "#EDEDEB"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M246.563 281.933H249.058V279.438H246.563V281.933Z",
    fill: "#EDEDEB"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 202.449H245.095V199.952H242.601V202.449Z",
    fill: "#EDEDEB"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 206.632H245.095V204.137H242.601V206.632Z",
    fill: "#EDEDEB"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 210.816H245.095V208.321H242.601V210.816Z",
    fill: "#EDEDEB"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 214.999H245.095V212.503H242.601V214.999Z",
    fill: "#EDEDEB"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 219.182H245.095V216.687H242.601V219.182Z",
    fill: "#EDEDEB"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 223.365H245.095V220.871H242.601V223.365Z",
    fill: "#EDEDEB"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 227.55H245.095V225.054H242.601V227.55Z",
    fill: "#EDEDEB"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 231.732H245.095V229.236H242.601V231.732Z",
    fill: "#EDEDEB"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 235.915H245.095V233.421H242.601V235.915Z",
    fill: "#EDEDEB"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 240.099H245.095V237.604H242.601V240.099Z",
    fill: "#EDEDEB"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 244.283H245.095V241.786H242.601V244.283Z",
    fill: "#EDEDEB"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 248.465H245.095V245.969H242.601V248.465Z",
    fill: "#EDEDEB"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 252.648H245.095V250.154H242.601V252.648Z",
    fill: "#EDEDEB"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 256.832H245.095V254.338H242.601V256.832Z",
    fill: "#EDEDEB"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 261.016H245.095V258.519H242.601V261.016Z",
    fill: "#EDEDEB"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 265.198H245.095V262.703H242.601V265.198Z",
    fill: "#EDEDEB"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 269.382H245.095V266.887H242.601V269.382Z",
    fill: "#EDEDEB"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 273.566H245.095V271.07H242.601V273.566Z",
    fill: "#EDEDEB"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 277.748H245.095V275.252H242.601V277.748Z",
    fill: "#EDEDEB"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M242.601 281.933H245.095V279.438H242.601V281.933Z",
    fill: "#EDEDEB"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M268.581 218.742H266.086V216.247H268.581V218.742Z",
    fill: "#EDEDEB"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 222.925H268.581V220.429H266.086V222.925Z",
    fill: "#EDEDEB"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 227.107H268.581V224.613H266.086V227.107Z",
    fill: "#EDEDEB"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 231.292H268.581V228.798H266.086V231.292Z",
    fill: "#EDEDEB"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 235.477H268.581V232.981H266.086V235.477Z",
    fill: "#EDEDEB"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 239.66H268.581V237.164H266.086V239.66Z",
    fill: "#EDEDEB"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 243.842H268.581V241.347H266.086V243.842Z",
    fill: "#EDEDEB"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 248.026H268.581V245.531H266.086V248.026Z",
    fill: "#EDEDEB"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 252.21H268.581V249.714H266.086V252.21Z",
    fill: "#EDEDEB"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M266.086 256.392H268.581V253.897H266.086V256.392Z",
    fill: "#EDEDEB"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M264.618 218.742H262.123V216.247H264.618V218.742Z",
    fill: "#EDEDEB"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 222.925H264.617V220.429H262.123V222.925Z",
    fill: "#EDEDEB"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 227.107H264.617V224.613H262.123V227.107Z",
    fill: "#EDEDEB"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 231.292H264.617V228.798H262.123V231.292Z",
    fill: "#EDEDEB"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 235.477H264.617V232.981H262.123V235.477Z",
    fill: "#EDEDEB"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 239.66H264.617V237.164H262.123V239.66Z",
    fill: "#EDEDEB"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 243.842H264.617V241.347H262.123V243.842Z",
    fill: "#EDEDEB"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 248.026H264.617V245.531H262.123V248.026Z",
    fill: "#EDEDEB"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 252.21H264.617V249.714H262.123V252.21Z",
    fill: "#EDEDEB"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M284.011 290.808H288.2V57.4868H284.011V290.808Z",
    fill: "#DADBD8"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M362.797 290.808H366.985V57.4868H362.797V290.808Z",
    fill: "#DADBD8"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M441.582 290.808H445.77V57.4868H441.582V290.808Z",
    fill: "#DADBD8"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M178.194 322.408H143.568V272.526C143.568 270.09 145.543 268.115 147.978 268.115H173.785C176.22 268.115 178.194 270.09 178.194 272.526V322.408Z",
    fill: "#EDEDEB"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M178.194 279.343H143.568V275.453H178.194V279.343Z",
    fill: "#E2E2E0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M171.883 315.831H163.257C161.945 315.831 160.881 316.895 160.881 318.207V322.408H174.26V318.207C174.26 316.895 173.196 315.831 171.883 315.831Z",
    fill: "#DADBD8"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M174.306 322.408H164.71C163.86 322.408 163.171 321.718 163.171 320.869C163.171 320.02 163.86 319.33 164.71 319.33H174.306C175.154 319.33 175.843 320.02 175.843 320.869C175.843 321.718 175.154 322.408 174.306 322.408Z",
    fill: "#E2E2E0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M299.06 23.5775C299.06 36.6001 309.617 47.1572 322.639 47.1572C335.662 47.1572 346.218 36.6001 346.218 23.5775C346.218 10.5558 335.662 -0.00025177 322.639 -0.00025177C309.617 -0.00025177 299.06 10.5558 299.06 23.5775Z",
    fill: "#DADBD8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M302.59 23.5779C302.59 34.6506 311.566 43.626 322.638 43.626C333.711 43.626 342.686 34.6506 342.686 23.5779C342.686 12.5063 333.711 3.53092 322.638 3.53092C311.566 3.53092 302.59 12.5063 302.59 23.5779Z",
    fill: "#EDEDEB"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M323.584 9.8271V23.8418L332.871 18.5863",
    fill: "#EDEDEB"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M322.583 9.82551V23.8402C322.583 24.1976 322.771 24.5249 323.08 24.7051C323.389 24.8853 323.766 24.8873 324.078 24.7111L333.364 19.4556C333.846 19.1833 334.015 18.5727 333.743 18.0922C333.47 17.6107 332.86 17.4415 332.378 17.7138L324.585 22.1234V9.82551C324.585 9.27293 324.137 8.82446 323.584 8.82446C323.031 8.82446 322.583 9.27293 322.583 9.82551Z",
    fill: "#DADBD8"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0326 253.694C95.2307 250.727 92.2636 253.307 92.2636 253.307C92.6871 247.622 87.4562 243.732 87.4562 243.732C87.4562 243.732 93.5353 243.732 94.3831 237.932C95.0243 233.545 93.4828 234.02 91.489 234.495C90.8468 234.648 90.1575 234.801 89.4794 234.791C86.6953 234.751 83.7855 242.885 87.4562 247.459C91.1276 252.033 90.1434 259.84 81.6658 267.35C79.5979 269.182 78.1915 271.621 77.2412 274.26C77.8813 267.36 78.2418 257.64 76.212 251.15C72.7643 240.129 79.3345 237.162 81.2423 231.651C83.1494 226.141 76.212 221.477 76.212 221.477C76.212 221.477 82.7255 218.511 79.5468 215.119C76.3677 211.728 69.7967 212.189 69.7967 216.622C69.7967 221.054 74.2474 222.749 74.2474 222.749C74.2474 222.749 79.3345 228.048 79.3345 230.803C79.3345 233.559 74.2474 239.493 74.2474 239.493C74.2474 239.493 76.5792 234.414 71.9165 234.197C67.2534 233.983 65.7694 240.129 67.6772 242.885C69.5843 245.639 72.7643 243.308 72.7643 243.308C72.7643 243.308 73.1342 249.243 74.2209 252.846C74.6987 254.431 74.4743 260.647 74.0726 267.115C73.1334 264.78 71.8055 262.639 69.9437 260.992C61.4657 253.482 60.4822 245.675 64.1532 241.101C67.8243 236.526 64.9146 228.393 62.1304 228.432C61.452 228.441 60.7626 228.289 60.1205 228.136C58.127 227.662 56.5856 227.187 57.2269 231.574C58.075 237.374 64.1532 237.374 64.1532 237.374C64.1532 237.374 58.9224 241.263 59.3467 246.949C59.3467 246.949 56.3791 244.368 54.5776 247.335C51.3613 252.633 58.8164 255.919 60.0693 253.312C60.0693 253.312 75.8784 264.503 72.0635 280.612L72.9492 281.92C72.8359 283.22 72.7643 284.003 72.7643 284.003L74.0003 283.47L75.4068 285.547C75.3342 289.574 75.7666 292.55 75.7666 292.55L79.5468 286.97C75.7314 270.861 91.5406 259.67 91.5406 259.67C92.7935 262.278 100.249 258.992 97.0326 253.694Z",
    fill: "#DADBD8"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7666 292.55C75.7666 292.55 75.399 290.021 75.3986 286.471C75.3986 286.17 75.4013 285.863 75.4068 285.547L74.0003 283.47L72.7643 284.003C72.7643 284.003 72.8358 283.22 72.9492 281.92L72.0635 280.612C72.4733 278.881 72.6568 277.208 72.6575 275.599C72.6646 262.228 60.0693 253.312 60.0693 253.312C59.7682 253.938 59.1092 254.224 58.3264 254.224C56.4209 254.224 53.7811 252.529 53.7791 249.913C53.7784 249.129 54.0141 248.263 54.5776 247.335C55.2353 246.252 56.0482 245.908 56.8158 245.908C58.1504 245.908 59.3467 246.949 59.3467 246.949C59.3303 246.727 59.322 246.507 59.322 246.29C59.3232 240.965 64.1532 237.374 64.1532 237.374C64.1532 237.374 58.075 237.374 57.2269 231.574C57.126 230.885 57.079 230.315 57.0794 229.847C57.0806 228.267 57.6191 227.84 58.4375 227.84C58.9188 227.84 59.4975 227.988 60.1205 228.136C60.7435 228.284 61.4106 228.432 62.069 228.432C62.0894 228.432 62.1097 228.432 62.1304 228.432C62.1371 228.432 62.1437 228.431 62.1503 228.431C63.9898 228.431 65.8769 231.985 65.8792 235.711C65.88 237.612 65.3905 239.559 64.1532 241.101C62.8484 242.726 62.1316 244.761 62.1304 247.045C62.1285 251.187 64.4794 256.152 69.9437 260.992C71.8055 262.639 73.1334 264.78 74.0726 267.115C74.3135 263.237 74.4907 259.449 74.4907 256.696C74.4911 254.858 74.4121 253.481 74.2209 252.846C73.1342 249.243 72.7643 243.308 72.7643 243.308C72.7643 243.308 71.5078 244.229 70.1005 244.229C69.2692 244.229 68.3855 243.908 67.6772 242.885C67.1353 242.102 66.8667 241.046 66.8674 239.939C66.869 237.217 68.4969 234.192 71.6795 234.192C71.7573 234.192 71.8367 234.194 71.9165 234.197C74.2478 234.306 74.8304 235.63 74.8304 236.926C74.8304 238.224 74.2474 239.493 74.2474 239.493C74.2474 239.493 79.3345 233.559 79.3345 230.803C79.3345 228.048 74.2474 222.749 74.2474 222.749C74.2474 222.749 69.7967 221.054 69.7967 216.622C69.7967 214.127 71.8777 212.89 74.2646 212.89C76.1186 212.89 78.157 213.637 79.5468 215.119C80.1704 215.785 80.4211 216.434 80.4207 217.049C80.4195 219.561 76.212 221.477 76.212 221.477C76.212 221.477 81.5711 225.08 81.5739 229.694C81.5743 230.329 81.473 230.984 81.2423 231.651C79.72 236.048 75.2298 238.825 75.2278 245.366C75.2274 247.024 75.5148 248.922 76.212 251.15C77.3617 254.826 77.7445 259.539 77.7441 264.188C77.7437 267.747 77.5189 271.269 77.2412 274.26C78.1915 271.621 79.5979 269.182 81.6658 267.35C87.1301 262.509 89.481 257.546 89.479 253.404C89.4783 251.119 88.7612 249.085 87.4562 247.459C86.219 245.918 85.7294 243.971 85.7302 242.07C85.7326 238.344 87.6193 234.791 89.4587 234.791C89.4658 234.791 89.4724 234.791 89.4794 234.791C89.4994 234.792 89.5197 234.792 89.5401 234.792C90.1986 234.792 90.8661 234.643 91.489 234.495C92.1123 234.347 92.691 234.198 93.1732 234.198C93.9908 234.198 94.5293 234.626 94.53 236.206C94.5304 236.674 94.4836 237.243 94.383 237.932C93.5353 243.732 87.4562 243.732 87.4562 243.732C87.4562 243.732 92.2867 247.323 92.2879 252.649C92.2883 252.865 92.28 253.084 92.2636 253.307C92.2636 253.307 93.4598 252.266 94.7944 252.266C95.5616 252.266 96.3749 252.611 97.0326 253.694C97.5957 254.622 97.832 255.488 97.8312 256.271C97.8289 258.886 95.1889 260.583 93.2834 260.583C92.5006 260.583 91.8417 260.297 91.5406 259.67C91.5406 259.67 81.615 266.697 79.3911 277.628C79.3743 277.711 79.3579 277.795 79.3419 277.878C79.0916 279.185 78.952 280.546 78.9524 281.957C78.9536 283.566 79.137 285.24 79.5468 286.97L75.7666 292.55Z",
    fill: "#DADBD8"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9404 322.408H57.7282L53.821 282.76H97.8472L93.9404 322.408Z",
    fill: "#E2E2E0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7808 287.134H51.8879V278.386H99.7808V287.134Z",
    fill: "#EDEDEB"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M444.355 356.4C444.355 362.661 357.458 367.735 250.263 367.735C143.068 367.735 56.1704 362.661 56.1704 356.4C56.1704 350.14 143.068 345.065 250.263 345.065C357.458 345.065 444.355 350.14 444.355 356.4Z",
    fill: "#F3F2F1"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M410.879 324.845C411.032 323.819 414.534 299.646 407.516 291.301C405.962 289.454 404.002 288.487 401.689 288.43C387.521 288.099 385.583 299.478 385.565 299.595L387.236 299.851C387.301 299.444 388.981 289.814 401.648 290.121C403.481 290.166 404.977 290.908 406.222 292.388C412.755 300.158 409.243 324.352 409.207 324.595L410.879 324.845Z",
    fill: "#406FBF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M411.737 323.745L413.426 323.692C413.418 323.47 412.864 301.419 423.729 296.862C434.377 292.402 439.167 301.573 439.367 301.967L440.877 301.207C440.821 301.098 435.201 290.219 423.076 295.303C411.141 300.307 411.707 322.79 411.737 323.745Z",
    fill: "#406FBF"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M411.685 325.477C411.686 325.125 411.787 290.249 418.587 280.049C425.116 270.256 435.648 274.866 436.093 275.069L436.792 273.529C436.67 273.474 424.516 268.109 417.181 279.112C410.099 289.735 409.997 324.021 409.996 325.474L411.685 325.477Z",
    fill: "#406FBF"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M399.661 289.269C399.661 289.269 405.847 291.55 404.008 296.933C402.169 302.316 382.608 311.179 382.608 311.179C382.608 311.179 374.416 303.67 381.94 291.458C389.463 279.245 399.494 285.415 399.661 289.269Z",
    fill: "#406FBF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M418.894 278.213C418.894 278.213 414.501 277.741 414.856 275.066C415.209 272.391 431.928 265.506 441.792 276.639C441.792 276.639 435.476 287.489 426.346 287.63C417.215 287.773 418.894 278.213 418.894 278.213Z",
    fill: "#406FBF"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M423.402 296.083C423.402 296.083 420.371 293.635 423.641 292.44C426.913 291.246 442.963 291.586 443.13 307.484C443.13 307.484 424.437 310.591 422.123 304.535C419.809 298.479 423.402 296.083 423.402 296.083Z",
    fill: "#406FBF"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M382.609 311.179C382.609 311.179 378.758 307.65 378.761 301.496C378.762 298.673 379.574 295.298 381.94 291.458C385.268 286.056 389.086 284.25 392.324 284.25C396.407 284.25 399.569 287.12 399.662 289.269C399.662 289.269 404.345 290.995 404.35 294.991C404.351 295.587 404.248 296.234 404.008 296.933C402.169 302.316 382.609 311.179 382.609 311.179Z",
    fill: "#3563B7"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M426.145 287.632C419.649 287.632 418.772 282.619 418.772 279.907C418.772 278.902 418.894 278.212 418.894 278.212C418.894 278.212 414.838 277.776 414.836 275.369C414.835 275.271 414.842 275.17 414.856 275.066C415.062 273.502 420.864 270.499 427.617 270.499C432.416 270.499 437.695 272.013 441.792 276.638C441.792 276.638 441.721 276.761 441.582 276.981C440.639 278.473 436.588 284.439 430.755 286.73C429.379 287.27 427.903 287.606 426.346 287.63C426.279 287.631 426.212 287.632 426.145 287.632Z",
    fill: "#3563B7"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M433.304 308.281C428.398 308.281 423.265 307.526 422.123 304.536C421.56 303.063 421.347 301.806 421.346 300.748C421.344 297.456 423.402 296.084 423.402 296.084C423.402 296.084 422.124 295.051 422.123 294C422.123 293.433 422.495 292.859 423.642 292.441C424.303 292.2 425.489 292.02 426.958 292.02C432.755 292.02 442.997 294.801 443.13 307.485C443.13 307.485 438.336 308.281 433.304 308.281Z",
    fill: "#3563B7"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M396.337 357.235H425.345L428.475 325.475H393.208L396.337 357.235Z",
    fill: "#406FBF"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M425.345 357.235H396.337L393.553 328.979H428.129L427.177 338.638L427.153 338.888L425.345 357.235Z",
    fill: "#90B4E3"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M391.659 328.979H430.023V321.97H391.659V328.979Z",
    fill: "#406FBF"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M430.023 328.979H391.659V321.97H430.023V322.525V322.775V328.979Z",
    fill: "#5D87CD"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M363.505 334.468L334.662 331.633V291.099H323.231V331.622L294.27 334.468C291.396 334.752 289.204 337.169 289.204 340.057V344.389H327.828H329.947H368.571V340.057C368.571 337.169 366.38 334.752 363.505 334.468Z",
    fill: "#17282F"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M368.571 344.389H313.791L313.098 332.618L323.231 331.622V299.197C323.861 299.587 324.604 299.811 325.4 299.811H332.492C333.288 299.811 334.031 299.587 334.662 299.197V322.525V322.775V331.633L363.505 334.468C366.38 334.752 368.571 337.169 368.571 340.057V344.389ZM307.487 344.389H289.204V340.057C289.204 339.313 289.35 338.599 289.615 337.947L290.571 342.491L297.13 340.81L296.253 334.274L306.686 333.248L307.487 344.389Z",
    fill: "#405158"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M299.731 349.762C299.731 353.889 296.385 357.235 292.258 357.235C288.13 357.235 284.784 353.889 284.784 349.762C284.784 345.633 288.13 342.288 292.258 342.288C296.385 342.288 299.731 345.633 299.731 349.762Z",
    fill: "#17282F"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M358.046 349.762C358.046 353.889 361.391 357.235 365.52 357.235C369.647 357.235 372.993 353.889 372.993 349.762C372.993 345.633 369.647 342.288 365.52 342.288C361.391 342.288 358.046 345.633 358.046 349.762Z",
    fill: "#17282F"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M332.493 299.811H325.401C323.115 299.811 321.262 297.959 321.262 295.674V263.708H336.631V295.674C336.631 297.959 334.779 299.811 332.493 299.811Z",
    fill: "#17282F"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M332.493 299.811H325.401C323.115 299.811 321.262 297.959 321.262 295.674V267.85H336.631V286.73V290.807V295.674C336.631 297.959 334.779 299.811 332.493 299.811Z",
    fill: "#57666B"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M356.275 200.349C356.275 200.349 358.453 254.402 343.404 263.709H360.586C360.586 263.709 373.897 245.294 370.135 200.349H356.275Z",
    fill: "#17282F"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M364.054 256.89C363.292 256.419 362.393 256.148 361.432 256.148H349.412C354.942 244.46 356.164 223.963 356.354 211.331H370.745C370.786 212.878 370.806 214.388 370.805 215.862C370.804 226.118 369.858 234.561 368.541 241.346C368.43 241.92 368.316 242.484 368.2 243.034C368.078 243.611 367.954 244.171 367.827 244.722C367.629 245.585 367.426 246.418 367.219 247.218C366.192 251.19 365.075 254.396 364.054 256.89Z",
    fill: "#57666B"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M294.441 256.148H361.433C364.196 256.148 366.438 258.389 366.438 261.154V267.851H289.436V261.154C289.436 258.389 291.677 256.148 294.441 256.148Z",
    fill: "#17282F"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M288.239 262H367.633C368.745 262 369.646 262.9 369.646 264.014V265.837C369.646 266.949 368.745 267.851 367.633 267.851H288.239C287.127 267.851 286.226 266.949 286.226 265.837V264.014C286.226 262.9 287.127 262 288.239 262Z",
    fill: "#17282F"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M367.633 267.851H309.29L308.946 262H367.633C368.745 262 369.646 262.9 369.646 264.014V265.837C369.646 266.949 368.745 267.851 367.633 267.851ZM301.984 267.851H290.192C289.933 265.594 289.705 263.622 289.515 262H301.564L301.984 267.851Z",
    fill: "#9BA6A6"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M374.348 211.331H346.824C338.761 211.331 332.225 204.794 332.225 196.732V185.968C332.225 177.905 338.761 171.369 346.824 171.369H374.348C382.41 171.369 388.947 177.905 388.947 185.968V196.732C388.947 204.794 382.41 211.331 374.348 211.331Z",
    fill: "#17282F"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M263.327 127.201L257.834 112.716C257.834 112.716 260.19 110.535 258.574 108.323C256.958 106.112 246.822 99.8882 244.974 100.982C243.126 102.076 239.023 106.201 241.241 108.489C243.459 110.778 253.279 114.599 253.279 114.599L258.136 133.604L263.327 127.201Z",
    fill: "#F47072"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M301.699 154.741C301.699 154.741 276.703 149.604 273.993 148.378C271.283 147.15 261.22 117.68 261.22 117.68L253.508 121.285C253.508 121.285 259.715 150.857 266.064 157.889C272.412 164.921 299.489 170.868 299.489 170.868L301.699 154.741Z",
    fill: "#406FBF"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M299.093 170.773C299.072 170.768 299.05 170.763 299.028 170.757C298.211 170.574 296.361 170.142 293.921 169.506C296.184 169.918 298.004 170.209 299.078 170.372C299.082 170.505 299.087 170.639 299.093 170.773Z",
    fill: "#3563B7"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M277.934 164.526C272.828 162.572 268.233 160.296 266.06 157.892C264.12 155.739 262.191 151.474 260.449 146.591C262.192 151.473 264.121 155.736 266.065 157.888C268.235 160.292 272.829 162.57 277.934 164.526ZM300.976 154.592C299.07 154.198 293.684 153.075 288.2 151.874V151.871C293.685 153.072 299.071 154.195 300.977 154.589C300.977 154.59 300.977 154.591 300.976 154.592ZM284.012 150.943C279.195 149.855 275.014 148.839 273.994 148.377C273.614 148.205 273.089 147.477 272.468 146.353C273.09 147.478 273.617 148.205 273.998 148.377C275.018 148.838 279.198 149.853 284.012 150.941V150.943Z",
    fill: "#BABCBA"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M288.2 151.874C286.791 151.566 285.375 151.251 284.011 150.943V150.941C285.376 151.248 286.79 151.563 288.2 151.871V151.874Z",
    fill: "#A7AAA9"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M256.726 134.498C254.764 127.27 253.506 121.282 253.506 121.282L254.83 120.664L254.831 120.667L253.509 121.285C253.509 121.285 254.765 127.27 256.726 134.498ZM259.944 118.277V118.276L261.215 117.682C261.215 117.682 261.215 117.683 261.216 117.683L259.944 118.277Z",
    fill: "#BABCBA"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M254.831 120.666L254.83 120.663L259.944 118.276V118.277L254.831 120.666Z",
    fill: "#C75B5B"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M288.988 168.154C288.765 168.09 288.54 168.024 288.312 167.958C285.005 166.998 281.354 165.834 277.933 164.525C272.828 162.569 268.234 160.291 266.064 157.888C264.12 155.735 262.191 151.472 260.448 146.59C259.059 142.699 257.788 138.415 256.725 134.497C254.764 127.269 253.508 121.284 253.508 121.284L254.83 120.665L259.944 118.276L261.215 117.682C261.253 117.796 268.662 139.48 272.467 146.352C273.088 147.477 273.613 148.204 273.993 148.377C275.013 148.838 279.194 149.854 284.011 150.942C285.374 151.251 286.791 151.565 288.199 151.873C293.683 153.074 299.07 154.197 300.976 154.591C300.228 156.495 299.724 158.7 299.417 161.107C297.149 161.931 291.466 164.302 288.988 168.154Z",
    fill: "#3563B7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M261.341 117.102L262.935 120.173L253.024 123.587L253.407 119.831L261.341 117.102Z",
    fill: "#406FBF"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M293.859 169.495C292.333 169.217 290.608 168.884 288.777 168.501C288.843 168.386 288.912 168.274 288.984 168.162C290.752 168.67 292.409 169.118 293.859 169.495Z",
    fill: "#BABCBA"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M293.922 169.507C293.902 169.503 293.881 169.5 293.86 169.496C292.409 169.118 290.752 168.671 288.985 168.162C288.986 168.16 288.988 168.158 288.989 168.155C290.782 168.672 292.458 169.126 293.922 169.507Z",
    fill: "#3563B7"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M299.078 170.372C298.003 170.209 296.184 169.918 293.921 169.506C292.458 169.126 290.781 168.671 288.988 168.155C291.466 164.303 297.149 161.931 299.417 161.107C299.053 163.965 298.966 167.108 299.078 170.372Z",
    fill: "#2555AD"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M336.937 134.343C336.937 134.343 338.408 148.188 333.278 151.588C328.148 154.986 302.919 151.004 300.057 145.436C297.195 139.867 307.965 124.742 307.965 124.742L336.937 134.343Z",
    fill: "#17282F"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M234.839 316.515L241.421 318.1L244.754 309.013L247.779 300.747L240.281 297.549L237.398 307.58L234.839 316.515Z",
    fill: "#F47072"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M242.984 308.668L237.397 307.58L238.374 304.18L242.965 305.803L242.984 308.668Z",
    fill: "#C75B5B"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M238.06 302.783L247.19 306.177C247.19 306.177 271.545 245.284 276.55 245.073C278.521 244.99 287.609 248.568 298.687 252.146C315.756 257.66 337.546 263.174 345.293 255.294C358.066 242.31 339.597 211.007 339.597 211.007C339.597 211.007 308.874 206.623 306.562 213.56C306.111 214.901 305.621 217.534 305.261 219.786C304.91 221.908 304.67 223.69 304.67 223.69L304.65 223.681C303.699 223.44 272.857 215.482 260.704 223.69C248.361 232.039 238.06 302.783 238.06 302.783Z",
    fill: "#406FBF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M242.928 300.069L238.699 298.632C239.46 293.849 240.869 285.412 242.77 275.858L242.928 300.069ZM249.815 299.713L250.174 245.1C253.334 234.66 256.923 226.248 260.704 223.69C264.818 220.911 271.072 219.985 277.586 219.985C285.316 219.985 293.411 221.291 298.713 222.351L300.865 252.272C286.509 247.038 275.97 240.949 275.97 240.949C275.97 240.949 264.207 243.952 263.957 254.213C263.956 254.268 263.955 254.324 263.955 254.382C263.955 256.143 264.562 259.317 265.577 263.399C262.11 270.762 258.402 279.26 255.231 286.73C254.637 288.13 254.062 289.494 253.51 290.808C252.092 294.189 250.83 297.239 249.815 299.713ZM332.417 259.221C329.555 259.221 326.442 258.925 323.195 258.418C323.196 258.418 323.197 258.418 323.198 258.418C323.221 258.418 323.229 258.418 323.229 258.418C318.207 257.549 313.243 256.292 308.527 254.847L306.721 224.118L322.639 227.435C322.639 227.435 313.753 222.526 306.489 220.164L306.181 214.939C306.308 214.403 306.437 213.932 306.562 213.559C306.563 213.558 306.563 213.558 306.563 213.557L307.983 213.448L308.156 215.126L309.787 214.958L309.619 213.322L328.198 211.889L328.439 214.23L330.071 214.062L329.834 211.763L339.593 211.01V211.007C339.595 211.007 339.596 211.007 339.596 211.007C339.596 211.007 349.797 228.295 349.794 242.505C349.793 247.416 348.573 251.959 345.292 255.294C342.516 258.118 337.937 259.221 332.417 259.221Z",
    fill: "#A4C3E9"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M290.571 342.49L297.13 340.81L295.868 331.401L294.696 322.77L286.585 323.497L288.691 333.554L290.571 342.49Z",
    fill: "#F47072"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M295.893 331.588L295.868 331.402L295.349 327.586L295.366 327.583L295.914 331.582L295.893 331.588Z",
    fill: "#C3C5C2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M288.744 333.758L287.72 328.886L295.35 327.585L295.869 331.401L295.894 331.588L288.744 333.758Z",
    fill: "#C75B5B"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M250.959 302.8L237.662 298.28L237.093 303.728L247.179 307.293L250.959 302.8Z",
    fill: "#406FBF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M323.229 258.418C323.229 258.418 321.148 258.468 288.924 256.966C288.924 256.966 293.74 297.253 296.367 327.412L286.731 329.054C286.731 329.054 263.706 264.474 263.957 254.213C264.207 243.952 275.969 240.949 275.969 240.949C275.969 240.949 298.927 254.213 323.229 258.418Z",
    fill: "#406FBF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M286.73 329.054C286.73 329.054 270.782 284.32 265.576 263.399C264.561 259.318 263.955 256.143 263.955 254.382C263.955 254.324 263.956 254.268 263.957 254.213C264.207 243.952 275.969 240.949 275.969 240.949C275.969 240.949 286.508 247.038 300.864 252.272L301.243 257.531C297.726 257.373 293.648 257.185 288.924 256.966C288.924 256.966 293.74 297.253 296.367 327.412L295.35 327.585L287.72 328.886L287.714 328.886L286.73 329.054ZM323.198 258.418C322.95 258.418 320.968 258.395 308.704 257.862L308.526 254.847C313.242 256.292 318.206 257.549 323.229 258.418C323.229 258.418 323.221 258.418 323.198 258.418Z",
    fill: "#91AEE0"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M297.777 324.489L284.533 325.996L287.088 331.188L297.809 329.812L297.777 324.489Z",
    fill: "#406FBF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M322.639 227.436L306.721 224.118L306.489 220.165C313.754 222.526 322.639 227.436 322.639 227.436Z",
    fill: "#91AEE0"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M338.854 206.231L339.593 211.01L306.559 213.558L305.685 207.906L338.854 206.231Z",
    fill: "#17282F"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M306.559 213.558L305.825 208.809L305.768 207.902L307.403 207.819L307.982 213.449L306.562 213.558H306.559ZM309.618 213.322L309.045 207.736L327.673 206.796L328.198 211.889L309.618 213.322ZM329.833 211.763L329.315 206.712L338.854 206.231L339.593 211.01L329.833 211.763Z",
    fill: "#111D23"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M328.439 214.229L330.072 214.061L329.217 205.749L327.584 205.916L328.439 214.229Z",
    fill: "#406FBF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M313.767 213.391L321.004 212.925L320.651 207.437L313.414 207.903L313.767 213.391Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M308.156 215.125L309.786 214.957L308.932 206.643L307.3 206.811L308.156 215.125Z",
    fill: "#406FBF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M328.439 214.229L328.198 211.888L327.674 206.795L329.316 206.712L330.071 214.061L328.439 214.229Z",
    fill: "#A4C3E9"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M308.156 215.125L307.983 213.447L307.404 207.817L309.045 207.734L309.787 214.957L308.156 215.125Z",
    fill: "#A4C3E9"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1 154.285C301.1 154.285 309.532 156.93 320.131 156.386C330.732 155.842 343.404 160.99 343.404 160.99L338.854 206.231L305.685 207.905C305.685 207.905 294.541 170.126 301.1 154.285Z",
    fill: "#406FBF"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M306.427 128.738C306.427 128.738 308.292 106.767 326.657 114.75C349.708 124.771 331.378 151.531 320.118 146.037C308.857 140.542 306.427 128.738 306.427 128.738Z",
    fill: "#17282F"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M315.248 156.427C315.206 156.426 315.164 156.424 315.123 156.423C315.169 156.413 315.215 156.404 315.261 156.395C315.257 156.406 315.252 156.417 315.248 156.427Z",
    fill: "#BABCBA"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M315.614 185.395C314.753 177.918 316.223 164.187 316.223 164.187L312.104 170.027L311.576 157.613C312.702 157.053 313.901 156.67 315.123 156.423C315.164 156.424 315.206 156.426 315.248 156.427C314.691 157.713 313.795 157.872 313.795 157.872L317.265 159.923L318.266 159.641L320.006 164.876C319.924 165.309 319.843 165.747 319.764 166.188L318.266 164.187C316.4 171.988 315.614 185.395 315.614 185.395Z",
    fill: "#3563B7"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M317.266 159.922L326.761 157.24C320.91 153.212 323.861 144.207 323.861 144.207L314.454 147.515C314.955 149.077 315.272 150.402 315.463 151.534C316.446 157.402 313.795 157.871 313.795 157.871L317.266 159.922Z",
    fill: "#F47072"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M315.462 151.534C315.315 150.663 315.094 149.678 314.772 148.559C318.25 148.505 321.181 147.005 323.445 144.71C323.468 144.698 323.49 144.686 323.514 144.673C322.466 146.041 319.169 150.048 315.462 151.534Z",
    fill: "#C75B5B"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M320.593 119.363C312.261 117.519 308.592 121.386 306.081 129.837C302.944 140.397 303.636 148.547 314.56 148.561C329.398 148.58 334.429 122.424 320.593 119.363Z",
    fill: "#F47072"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M311.57 130.562C311.57 130.562 309.934 132.483 308.381 133.481C308.381 133.481 308.844 134.772 310.368 134.909L311.57 130.562Z",
    fill: "#F14453"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M316.821 131.01C316.654 131.69 316.886 132.333 317.339 132.444C317.794 132.556 318.297 132.095 318.465 131.414C318.632 130.732 318.401 130.091 317.946 129.979C317.493 129.867 316.989 130.329 316.821 131.01Z",
    fill: "#17282F"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M318.126 130.059L316.789 129.114C316.789 129.114 317.219 130.541 318.126 130.059Z",
    fill: "#17282F"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M308.392 128.786C308.225 129.467 308.457 130.108 308.911 130.221C309.365 130.333 309.869 129.871 310.036 129.189C310.203 128.509 309.972 127.867 309.517 127.755C309.063 127.644 308.559 128.104 308.392 128.786Z",
    fill: "#17282F"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M309.697 127.835L308.36 126.891C308.36 126.891 308.791 128.317 309.697 127.835Z",
    fill: "#17282F"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M318.146 125.637L318.233 125.648C318.447 125.678 319.02 125.781 319.618 126.06C320.219 126.34 320.833 126.788 321.188 127.498C321.278 127.677 321.496 127.75 321.676 127.66C321.855 127.57 321.927 127.351 321.837 127.172C321.316 126.138 320.396 125.579 319.631 125.276C318.864 124.973 318.232 124.917 318.21 124.915C318.011 124.897 317.835 125.044 317.817 125.244C317.8 125.443 317.947 125.619 318.146 125.637Z",
    fill: "#17282F"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M312.395 123.278C312.357 123.253 311.669 122.818 310.51 122.817C309.964 122.817 309.317 122.916 308.596 123.195C308.409 123.267 308.317 123.477 308.389 123.663C308.461 123.851 308.672 123.944 308.859 123.872C309.496 123.624 310.05 123.543 310.51 123.543C310.997 123.543 311.378 123.635 311.635 123.724C311.763 123.768 311.86 123.812 311.923 123.845L311.99 123.88L312.003 123.888L312.013 123.872L312.003 123.888L312.013 123.872L312.003 123.888C312.171 123.996 312.395 123.948 312.505 123.779C312.613 123.61 312.565 123.386 312.395 123.278Z",
    fill: "#17282F"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M326.589 135.419C326.589 135.419 324.21 127.712 325.969 122.557C325.969 122.557 310.951 112.159 306.427 128.737C306.427 128.737 308.108 113.499 322.504 116.337C336.876 119.171 332.201 140.115 323.423 144.722C323.423 144.722 328.052 140.234 326.589 135.419Z",
    fill: "#17282F"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M324.84 136.878C325.194 135.549 327.08 133.584 329.514 134.409C332.034 135.262 332.092 140.835 325.388 140.688C324.425 140.667 324.106 139.651 324.84 136.878Z",
    fill: "#F47072"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M308.878 138.076C309.173 139.179 309.31 141.173 309.31 141.173C309.493 141.193 309.676 141.213 309.859 141.224C312.347 141.435 313.57 140.711 314.173 139.845C314.5 139.37 314.637 138.844 314.691 138.412C314.759 137.912 314.693 137.54 314.693 137.54C313.308 138.216 310.973 138.198 309.727 138.135C309.206 138.114 308.878 138.076 308.878 138.076Z",
    fill: "#17282F"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M309.727 138.134L309.878 139.043C312.222 139.237 313.898 139.058 314.692 138.41C314.76 137.911 314.693 137.538 314.693 137.538C313.308 138.214 310.974 138.196 309.727 138.134Z",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M309.859 141.224C312.347 141.435 313.57 140.711 314.173 139.845C313.323 139.806 312.293 139.852 311.365 140.158C310.654 140.388 310.184 140.796 309.859 141.224Z",
    fill: "#F14453"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M320.625 120.029C320.625 120.029 320.947 134.481 329.618 136.216C338.29 137.95 328.811 117.644 328.811 117.644C328.811 117.644 315.899 109.211 307.294 115.154C298.688 121.097 306.427 128.737 306.427 128.737C306.427 128.737 308.246 118.003 320.625 120.029Z",
    fill: "#17282F"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M320.688 118.993C320.683 119.009 319.893 121.342 319.892 124.296C319.891 127.207 320.669 130.754 323.783 133.202C323.892 133.287 324.049 133.269 324.134 133.16C324.22 133.051 324.201 132.894 324.092 132.809C321.142 130.49 320.394 127.129 320.392 124.296C320.392 122.863 320.586 121.574 320.779 120.645C320.875 120.181 320.972 119.805 321.044 119.548C321.115 119.291 321.162 119.155 321.162 119.155C321.206 119.023 321.136 118.881 321.005 118.837C320.874 118.792 320.732 118.863 320.688 118.993Z",
    fill: "#17282F"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M332.151 139.189C331.048 142.128 328.215 143.783 325.824 142.885C323.434 141.987 322.39 138.877 323.493 135.939C324.596 133 327.429 131.346 329.82 132.243C332.21 133.14 333.254 136.251 332.151 139.189Z",
    fill: "#406FBF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M325.055 142.491C324.863 142.364 324.683 142.22 324.517 142.061C324.809 141.931 325.081 141.801 325.329 141.676C325.221 142.058 325.137 142.321 325.084 142.417C325.072 142.439 325.062 142.464 325.055 142.491ZM323.846 141.236C323.334 140.42 323.054 139.405 323.053 138.322C323.052 137.547 323.193 136.737 323.493 135.939C324.393 133.542 326.444 131.999 328.466 131.999C328.748 131.999 329.03 132.029 329.308 132.091C328.981 132.129 328.711 132.211 328.526 132.345C327.606 133.008 326.421 137.568 325.691 140.333C325.238 140.589 324.614 140.912 323.846 141.236Z",
    fill: "#2251AA"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M329.39 134.37C329.39 134.37 332.98 118.284 324.923 114.067C324.923 114.067 326.602 114.293 327.643 114.596C328.684 114.901 335.121 121.425 331.867 135.883L329.39 134.37Z",
    fill: "#406FBF"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M332.483 132.467C331.559 132.228 330.59 132.063 329.813 132.063C329.804 132.063 329.796 132.063 329.788 132.064C329.987 130.64 330.188 128.685 330.188 126.567C330.186 121.836 329.18 116.295 324.923 114.066C324.923 114.066 326.602 114.293 327.643 114.596C328.478 114.839 332.78 119.082 332.777 128.205C332.776 129.523 332.686 130.943 332.483 132.467Z",
    fill: "#3563B7"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M314.279 143.577C314.08 143.551 313.878 143.521 313.676 143.488L313.838 142.5C321.093 143.682 326.492 139.843 326.546 139.803L327.136 140.611C326.911 140.776 321.662 144.548 314.279 143.577Z",
    fill: "#406FBF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M316.712 143.734C315.94 143.734 315.14 143.687 314.311 143.579C314.467 143.417 314.574 143.206 314.606 142.966C314.612 142.916 314.615 142.868 314.615 142.82C314.615 142.746 314.608 142.674 314.593 142.604C315.293 142.687 315.975 142.724 316.632 142.724C320.885 142.724 324.201 141.175 325.691 140.332C325.552 140.857 325.429 141.319 325.328 141.675C325.081 141.8 324.809 141.929 324.516 142.06C322.679 142.877 319.974 143.734 316.712 143.734Z",
    fill: "#3563B7"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M331.813 138.786C331.083 140.729 329.211 141.823 327.63 141.229C326.05 140.636 325.36 138.579 326.089 136.637C326.818 134.695 328.69 133.601 330.271 134.195C331.852 134.787 332.541 136.844 331.813 138.786Z",
    fill: "#406FBF"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M313.384 143.905L312.581 143.799C311.984 143.721 311.565 143.174 311.643 142.577C311.721 141.981 312.269 141.561 312.865 141.639L313.668 141.745C314.265 141.824 314.684 142.371 314.606 142.967C314.528 143.563 313.98 143.983 313.384 143.905Z",
    fill: "#406FBF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M313.526 143.914C313.479 143.914 313.431 143.911 313.383 143.904L312.58 143.798C312.033 143.727 311.634 143.259 311.632 142.722C311.632 142.674 311.635 142.626 311.642 142.577C311.714 142.028 312.183 141.63 312.721 141.63C312.769 141.63 312.817 141.633 312.865 141.639L313.667 141.745C314.215 141.817 314.613 142.283 314.614 142.821C314.614 142.869 314.611 142.917 314.605 142.966C314.573 143.206 314.466 143.418 314.31 143.58C314.11 143.788 313.83 143.914 313.526 143.914Z",
    fill: "#2251AA"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M324.215 153.797L318.267 159.639L320.645 166.798L328.92 157.69L324.215 153.797Z",
    fill: "#406FBF"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M315.614 155.019L316.577 159.515L313.495 165.875L311.576 157.613L315.614 155.019Z",
    fill: "#406FBF"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M322.942 158.869L326.396 146.226C326.396 146.226 324.722 143.075 325.084 142.417C325.445 141.758 327.244 133.269 328.525 132.344C329.807 131.42 335.077 132.998 335.61 133.859C336.143 134.719 330.559 146.226 330.559 146.226L328.525 159.922L322.942 158.869Z",
    fill: "#F47072"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M343.405 160.99C352.909 170.718 333.859 192.76 322.943 191.821C312.027 190.883 323.214 150.916 323.214 150.916L330.206 152.065C330.206 152.065 327.753 169.361 328.526 170.718C328.89 171.358 331.507 168.507 334.506 165.656C337.87 162.459 341.716 159.261 343.405 160.99Z",
    fill: "#406FBF"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M323.632 191.85C323.399 191.85 323.169 191.841 322.942 191.821C319.366 191.513 318.161 187.017 318.159 181.108C318.156 168.984 323.214 150.916 323.214 150.916L330.205 152.065C330.205 152.065 330.173 152.289 330.118 152.689C330.043 153.234 329.923 154.108 329.782 155.183C329.241 159.292 328.373 166.351 328.374 169.368C328.375 170.056 328.42 170.534 328.525 170.718C328.56 170.78 328.616 170.81 328.691 170.81C329.397 170.81 331.795 168.233 334.506 165.656C337.215 163.08 340.239 160.504 342.194 160.504C342.666 160.504 343.076 160.654 343.404 160.99C345.204 162.832 345.98 165.116 345.981 167.601C345.981 167.645 345.981 167.688 345.98 167.733C345.869 178.087 332.47 191.85 323.632 191.85Z",
    fill: "#3563B7"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M322.639 149.638L321.604 152.937L331.344 153.797V150.916L322.639 149.638Z",
    fill: "#406FBF"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M307.881 184.807H303.934C303.496 184.807 303.142 184.451 303.142 184.014V176.567C303.142 176.13 303.496 175.774 303.934 175.774H307.881C308.319 175.774 308.673 176.13 308.673 176.567V184.014C308.673 184.451 308.319 184.807 307.881 184.807ZM303.472 176.369V182.507H307.96V176.369H303.472Z",
    fill: "#A4C3E9"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M303.472 182.507H307.96V176.368H303.472V182.507Z",
    fill: "#7F9BCF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M305.32 173.595V177.214H306.31V173.595H305.32Z",
    fill: "#17282F"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M223.941 329.301C224.942 328.841 226.018 328.567 227.118 328.494C227.118 328.494 230.919 326.256 234.688 317.563L238.925 317.538C240.393 317.555 241.692 318.487 242.181 319.871C242.251 320.059 242.291 320.256 242.301 320.456C242.258 321.48 242.15 322.5 241.976 323.51C241.594 326.68 239.498 333.479 239.498 333.479L238.78 333.297L240.086 326.974C240.52 324.826 238.263 326.901 237.216 329.067C236.169 331.233 234.563 333.414 229.883 332.343C224.429 331.068 222.232 330.282 223.941 329.301Z",
    fill: "#406FBF"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M235.454 315.285C235.454 315.285 230.163 326.357 227.116 328.495C227.116 328.495 231.201 330.93 235.454 325.508C240.953 318.498 242.299 320.456 242.299 320.456C242.299 320.456 242.066 318.057 241.637 316.884C240.811 314.621 235.454 315.285 235.454 315.285Z",
    fill: "#F47072"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M282.222 355.683C283.085 354.998 284.067 354.476 285.117 354.145C285.117 354.145 288.28 351.07 289.879 341.729L293.99 340.701C295.419 340.37 296.904 340.966 297.705 342.195C297.818 342.361 297.904 342.544 297.961 342.735C298.162 343.74 298.298 344.757 298.369 345.779C298.751 348.949 298.326 356.052 298.326 356.052L297.585 356.044L297.354 349.592C297.267 347.402 295.566 349.954 295.063 352.306C294.559 354.658 293.516 357.158 288.716 357.228C283.116 357.283 280.795 357.04 282.222 355.683Z",
    fill: "#406FBF"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M290.085 339.334C290.085 339.334 287.57 351.346 285.117 354.144C285.117 354.144 289.662 355.541 292.509 349.267C296.189 341.151 297.961 342.734 297.961 342.734C297.961 342.734 297.166 340.459 296.47 339.42C295.131 337.419 290.085 339.334 290.085 339.334Z",
    fill: "#F47072"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M383.162 122.135H348.209C345.41 122.135 343.139 119.865 343.139 117.064V102.108C343.139 99.3068 345.41 97.0374 348.209 97.0374H383.162C385.963 97.0374 388.232 99.3068 388.232 102.108V117.064C388.232 119.865 385.963 122.135 383.162 122.135Z",
    fill: "#406FBF"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M355.223 119.274L344.693 133.588L361.682 120.234L355.223 119.274Z",
    fill: "#406FBF"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M355.617 109.586C355.617 110.401 354.955 111.062 354.141 111.062C353.325 111.062 352.663 110.401 352.663 109.586C352.663 108.77 353.325 108.108 354.141 108.108C354.955 108.108 355.617 108.77 355.617 109.586Z",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M363.314 109.586C363.314 110.401 362.653 111.062 361.838 111.062C361.022 111.062 360.36 110.401 360.36 109.586C360.36 108.77 361.022 108.108 361.838 108.108C362.653 108.108 363.314 108.77 363.314 109.586Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M371.011 109.586C371.011 110.401 370.35 111.062 369.535 111.062C368.719 111.062 368.057 110.401 368.057 109.586C368.057 108.77 368.719 108.108 369.535 108.108C370.35 108.108 371.011 108.77 371.011 109.586Z",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M378.708 109.586C378.708 110.401 378.047 111.062 377.232 111.062C376.416 111.062 375.754 110.401 375.754 109.586C375.754 108.77 376.416 108.108 377.232 108.108C378.047 108.108 378.708 108.77 378.708 109.586Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M242.685 102.4L217.758 88.9751C217.084 88.6117 216.832 87.7719 217.196 87.0972L225.145 72.3367C225.508 71.663 226.349 71.4117 227.023 71.7741L251.949 85.1992C252.624 85.5625 252.876 86.4034 252.513 87.0771L244.563 101.837C244.2 102.511 243.359 102.764 242.685 102.4Z",
    fill: "#406FBF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M243.342 102.566C243.12 102.566 242.894 102.512 242.685 102.4L217.758 88.9751C217.293 88.7239 217.028 88.2444 217.029 87.7499C217.03 87.5286 217.083 87.3054 217.195 87.0972L224.312 73.8843L225.008 74.6731L231.549 88.6928C232.111 89.8981 233.316 90.6479 234.617 90.6479C234.781 90.6479 234.946 90.6359 235.112 90.6118L251.635 88.1783L235.404 89.784C235.298 89.794 235.194 89.799 235.09 89.799C233.926 89.799 232.844 89.1603 232.286 88.1192L225.204 74.8944L225.321 75.0275C225.381 75.0946 225.457 75.1246 225.532 75.1246C225.678 75.1246 225.82 75.0105 225.82 74.8423C225.82 74.8303 225.819 74.8193 225.818 74.8073L225.532 72.2626L228.334 72.4808L251.949 85.1992C252.415 85.4505 252.68 85.93 252.679 86.4245C252.678 86.6447 252.625 86.8689 252.513 87.0772L244.563 101.837C244.312 102.302 243.834 102.566 243.342 102.566Z",
    fill: "#B8D2EF"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M234.618 90.6475C233.317 90.6475 232.112 89.8977 231.549 88.6924L225.009 74.6727L225.205 74.8939L232.287 88.1188C232.845 89.1599 233.927 89.7986 235.091 89.7986C235.195 89.7986 235.299 89.7936 235.404 89.7835L251.635 88.1779L235.113 90.6114C234.947 90.6354 234.782 90.6475 234.618 90.6475Z",
    fill: "#8FA5CB"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M205.557 70.8446C205.822 65.2747 209.945 54.053 214.961 50.6214C219.977 47.1888 216.678 51.9408 216.678 51.9408C216.678 51.9408 221.43 47.3199 223.937 47.4531C226.446 47.5852 223.937 50.4892 223.937 50.4892C223.937 50.4892 229.086 47.3149 231.462 47.45C233.838 47.5852 231.462 50.3571 231.462 50.3571C231.462 50.3571 235.686 47.3199 237.403 48.7734C239.118 50.225 215.49 65.8023 212.85 72.1379C210.209 78.4746 205.289 76.4815 205.557 70.8446Z",
    fill: "#406FBF"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M205.73 69.1572C206.597 63.257 210.412 53.736 214.961 50.6228C216.292 49.7118 217.038 49.3775 217.415 49.3775C217.651 49.3775 217.743 49.5096 217.743 49.7128C217.743 50.4076 216.678 51.9422 216.678 51.9422C216.678 51.9422 221.297 47.4514 223.831 47.4514C223.867 47.4514 223.903 47.4525 223.938 47.4545C224.776 47.4985 225.054 47.8509 225.053 48.3023C225.051 49.2023 223.938 50.4906 223.938 50.4906C223.938 50.4906 228.874 47.4474 231.311 47.4474C231.363 47.4474 231.413 47.4484 231.463 47.4514C232.256 47.4965 232.52 47.8358 232.519 48.2673C232.517 49.1292 231.463 50.3585 231.463 50.3585C231.463 50.3585 234.214 48.3804 236.178 48.3804C236.647 48.3804 237.072 48.4945 237.403 48.7748C237.463 48.8249 237.492 48.894 237.492 48.9791C237.485 50.802 223.977 60.1988 216.869 67.1331C216.268 67.3053 215.632 67.5005 214.961 67.7167C212.017 68.6707 208.657 69.1552 205.73 69.1572Z",
    fill: "#7DA6DD"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M225.852 70.0218L229.009 72.044C229.237 72.1891 229.117 72.5415 228.849 72.5205L225.533 72.2622L225.818 74.8069C225.849 75.0832 225.507 75.2353 225.321 75.0271L223.41 72.8618L225.852 70.0218Z",
    fill: "#406FBF"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M225.532 75.125C225.457 75.125 225.381 75.095 225.321 75.0279L225.204 74.8948L225.008 74.6735L223.698 73.19C225.209 72.3771 226.011 71.344 226.234 70.2679L229.009 72.0448C229.092 72.0968 229.128 72.1779 229.129 72.257C229.13 72.3901 229.029 72.5213 228.872 72.5213C228.864 72.5213 228.857 72.5213 228.849 72.5213L225.532 72.263L225.818 74.8077C225.819 74.8197 225.82 74.8307 225.82 74.8427C225.82 75.0109 225.679 75.125 225.532 75.125Z",
    fill: "#6D97D6"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M181.564 57.4876C181.564 57.4876 185.921 54.4504 192.522 56.4305C192.522 56.4305 194.42 65.1427 199.608 68.0467C202.459 69.6424 209.441 69.5042 214.962 67.7164C221.52 65.5931 224.732 65.5931 225.919 68.0467C227.044 70.3701 225.787 73.063 220.771 74.2512C215.754 75.4395 211.794 84.1516 202.686 84.2837C193.578 84.4159 188.783 75.2833 191.069 67.2549C191.069 67.2549 188.297 61.2696 181.564 57.4876Z",
    fill: "#406FBF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M202.491 84.2842C197.565 84.2842 193.924 81.5603 192.015 77.7854C192.455 77.7984 192.891 77.8044 193.323 77.8044C196.14 77.8044 198.738 77.5281 200.572 77.0286C203.226 76.3048 204.675 74.6761 204.672 73.1325C204.67 71.5088 203.06 69.9782 199.552 69.6929C197.455 69.5227 193.924 67.7458 190.01 65.4214C188.658 63.3522 185.952 59.9517 181.564 57.4871C181.564 57.4871 184.043 55.7603 188.092 55.7603C189.412 55.7603 190.899 55.9435 192.522 56.43C192.522 56.43 194.42 65.1421 199.608 68.0462C200.936 68.7889 203.157 69.1563 205.711 69.1563C208.643 69.1563 212.011 68.6718 214.962 67.7158C218.123 66.6927 220.506 66.1632 222.26 66.1632C224.146 66.1632 225.303 66.7748 225.919 68.0462C226.169 68.5637 226.302 69.0993 226.301 69.6328C226.3 69.845 226.279 70.0573 226.235 70.2675C226.012 71.3436 225.21 72.3767 223.699 73.1895C222.919 73.61 221.949 73.9724 220.771 74.2507C216.681 75.2197 213.292 81.1899 207.244 83.4333C206.058 83.8737 204.77 84.1701 203.353 84.2582C203.134 84.2712 202.912 84.2802 202.686 84.2832C202.621 84.2842 202.555 84.2842 202.491 84.2842Z",
    fill: "#90B4E3"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M223.41 69.6951C223.41 69.9424 223.211 70.1416 222.965 70.1416C222.718 70.1416 222.519 69.9424 222.519 69.6951C222.519 69.4499 222.718 69.2507 222.965 69.2507C223.211 69.2507 223.41 69.4499 223.41 69.6951Z",
    fill: "#17282F"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M200.571 77.0284C195.191 78.4949 183.246 78.0374 178.433 74.3255C173.62 70.6136 179.159 72.2854 179.159 72.2854C179.159 72.2854 173.298 69.1921 172.649 66.7656C172 64.339 175.537 65.8286 175.537 65.8286C175.537 65.8286 170.928 61.9105 170.323 59.6091C169.719 57.3077 173.088 58.7121 173.088 58.7121C173.088 58.7121 168.897 55.6309 169.748 53.5507C170.6 51.4705 192.709 69.1381 199.551 69.6927C206.393 70.2482 206.016 75.5428 200.571 77.0284Z",
    fill: "#406FBF"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M193.322 77.8047C187.875 77.8047 181.604 76.7716 178.433 74.326C176.974 73.2009 176.467 72.5702 176.467 72.2379C176.468 71.9936 176.743 71.9105 177.118 71.9105C177.914 71.9105 179.159 72.2859 179.159 72.2859C179.159 72.2859 173.298 69.1927 172.649 66.7661C172.594 66.5609 172.569 66.3847 172.569 66.2325C172.57 65.5748 173.04 65.3767 173.607 65.3767C174.463 65.3767 175.537 65.8291 175.537 65.8291C175.537 65.8291 170.928 61.911 170.324 59.6096C170.273 59.4194 170.25 59.2542 170.25 59.1121C170.251 58.4784 170.708 58.2882 171.254 58.2882C172.07 58.2882 173.088 58.7127 173.088 58.7127C173.088 58.7127 169.631 56.171 169.634 54.1459C169.635 53.9416 169.67 53.7424 169.748 53.5512C169.796 53.4351 169.908 53.3811 170.08 53.3811C173.008 53.3811 193.089 69.1686 199.551 69.6932C203.059 69.9785 204.67 71.5091 204.672 73.1328C204.675 74.6764 203.225 76.3051 200.571 77.0289C198.737 77.5284 196.14 77.8047 193.322 77.8047Z",
    fill: "#7DA6DD"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M165.462 51.9479C164.515 51.6106 163.558 51.2962 162.592 51.0029C162.394 50.9439 162.184 51.055 162.124 51.2542C162.064 51.4524 162.176 51.6616 162.375 51.7217C163.329 52.011 164.275 52.3223 165.21 52.6547C165.405 52.7247 165.62 52.6226 165.689 52.4274C165.759 52.2322 165.657 52.018 165.462 51.9479Z",
    fill: "#406FBF"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M156.708 49.5034C154.728 49.088 152.729 48.7547 150.727 48.4994C150.522 48.4734 150.334 48.6185 150.308 48.8237C150.281 49.03 150.427 49.2171 150.632 49.2442C152.615 49.4974 154.594 49.8268 156.554 50.2382C156.757 50.2803 156.956 50.1501 156.999 49.9479C157.042 49.7447 156.911 49.5455 156.708 49.5034ZM144.695 47.9458C142.816 47.8207 140.769 47.7016 138.648 47.6575C138.441 47.6535 138.27 47.8187 138.265 48.0259C138.261 48.2331 138.426 48.4043 138.633 48.4083C140.736 48.4514 142.771 48.5695 144.645 48.6946C144.852 48.7086 145.03 48.5524 145.044 48.3452C145.058 48.138 144.902 47.9598 144.695 47.9458ZM132.579 47.7896C130.537 47.9368 128.503 48.2071 126.552 48.6576C126.349 48.7046 126.223 48.9058 126.27 49.108C126.316 49.3103 126.519 49.4364 126.72 49.3893C128.624 48.9499 130.621 48.6836 132.633 48.5384C132.84 48.5234 132.995 48.3442 132.98 48.137C132.965 47.9298 132.786 47.7746 132.579 47.7896ZM120.797 50.7287C118.97 51.6917 117.33 52.9401 115.985 54.5437C115.852 54.7019 115.873 54.9391 116.033 55.0723C116.191 55.2054 116.428 55.1844 116.561 55.0252C117.835 53.5056 119.392 52.3184 121.147 51.3924C121.33 51.2963 121.4 51.0691 121.303 50.8859C121.207 50.7027 120.98 50.6326 120.797 50.7287ZM113.288 60.0735C113.105 61.0085 113.023 61.9755 113.023 62.9676C113.023 64.0247 113.117 65.1088 113.286 66.208C113.318 66.4132 113.509 66.5543 113.714 66.5233C113.918 66.4913 114.059 66.2991 114.028 66.0949C113.864 65.0267 113.774 63.9796 113.774 62.9676C113.774 62.0176 113.853 61.0976 114.024 60.2167C114.064 60.0125 113.931 59.8163 113.728 59.7762C113.524 59.7372 113.328 59.8693 113.288 60.0735ZM114.775 72.1192C115.413 74.0282 116.175 75.9312 116.973 77.7771C117.056 77.9673 117.276 78.0554 117.466 77.9723C117.657 77.8902 117.744 77.67 117.662 77.4788C116.869 75.6469 116.116 73.7619 115.487 71.8809C115.422 71.6847 115.209 71.5786 115.012 71.6437C114.815 71.7097 114.709 71.922 114.775 72.1192ZM119.486 83.2829C120.434 85.301 121.305 87.1529 121.944 88.7336L121.959 88.7706C122.037 88.9629 122.255 89.056 122.447 88.9779C122.639 88.9008 122.733 88.6815 122.655 88.4893L122.64 88.4523C121.989 86.8416 121.114 84.9827 120.166 82.9636C120.078 82.7754 119.854 82.6953 119.666 82.7834C119.478 82.8715 119.398 83.0947 119.486 83.2829ZM124.157 94.3815C124.848 96.2415 125.504 98.1485 126.074 100.079C126.132 100.278 126.341 100.391 126.54 100.333C126.739 100.274 126.853 100.066 126.794 99.8663C126.218 97.9142 125.557 95.9922 124.861 94.1203C124.789 93.9261 124.572 93.827 124.378 93.899C124.184 93.9711 124.085 94.1873 124.157 94.3815ZM127.462 105.907C127.808 107.892 128.009 109.88 128.011 111.846C128.011 112.053 128.179 112.221 128.388 112.221C128.595 112.221 128.762 112.052 128.762 111.845C128.76 109.828 128.554 107.799 128.201 105.777C128.166 105.573 127.972 105.437 127.767 105.472C127.563 105.508 127.426 105.702 127.462 105.907ZM127.345 117.741C127.035 119.033 126.607 120.307 126.043 121.555C125.779 122.14 125.491 122.701 125.181 123.238C125.078 123.417 125.139 123.647 125.318 123.75C125.498 123.854 125.728 123.792 125.832 123.613C126.154 123.055 126.453 122.471 126.728 121.863C127.31 120.571 127.754 119.253 128.076 117.917C128.124 117.716 128 117.513 127.799 117.465C127.597 117.416 127.394 117.54 127.345 117.741ZM121.441 127.777C119.967 129.056 118.286 130.094 116.441 130.907C116.251 130.99 116.165 131.212 116.249 131.401C116.332 131.592 116.554 131.678 116.743 131.594C118.65 130.754 120.397 129.677 121.933 128.343C122.09 128.208 122.107 127.971 121.971 127.814C121.835 127.657 121.597 127.64 121.441 127.777ZM110.76 132.63C108.868 132.985 106.878 133.172 104.822 133.204C104.615 133.207 104.449 133.378 104.452 133.586C104.455 133.793 104.627 133.958 104.834 133.955C106.927 133.923 108.959 133.732 110.898 133.367C111.102 133.329 111.237 133.133 111.197 132.929C111.159 132.726 110.963 132.592 110.76 132.63ZM98.8465 132.887C96.8992 132.659 94.9224 132.312 92.9414 131.857C92.7397 131.81 92.5379 131.936 92.4917 132.138C92.4452 132.34 92.5711 132.542 92.7733 132.589C94.7797 133.05 96.7826 133.401 98.7593 133.633C98.9653 133.657 99.1518 133.51 99.1758 133.303C99.2 133.097 99.0525 132.911 98.8465 132.887ZM87.1694 130.227C85.2788 129.594 83.4061 128.87 81.5717 128.061C81.3821 127.978 81.1604 128.064 81.0767 128.253C80.9934 128.443 81.0794 128.664 81.2691 128.749C83.1241 129.565 85.0187 130.298 86.9308 130.939C87.1275 131.005 87.3402 130.899 87.406 130.702C87.4721 130.505 87.3657 130.292 87.1694 130.227ZM76.1957 125.389C74.4299 124.406 72.7261 123.345 71.1064 122.216C70.9363 122.097 70.7025 122.139 70.5837 122.309C70.4651 122.479 70.507 122.712 70.6771 122.831C72.3183 123.976 74.0435 125.05 75.8306 126.045C76.0116 126.146 76.2403 126.081 76.3412 125.9C76.4421 125.718 76.3772 125.49 76.1957 125.389ZM66.3929 118.517C64.8613 117.16 63.4543 115.736 62.1995 114.255C62.0657 114.097 61.8288 114.078 61.6704 114.212C61.5123 114.346 61.4928 114.583 61.627 114.741C62.9068 116.251 64.3392 117.701 65.8951 119.079C66.05 119.217 66.2874 119.203 66.425 119.047C66.5622 118.892 66.5481 118.655 66.3929 118.517Z",
    fill: "#406FBF"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7438 109.357C58.2491 108.486 57.8084 107.602 57.4268 106.707C57.3454 106.516 57.1249 106.427 56.9345 106.509C56.7437 106.59 56.6549 106.811 56.7363 107.001C57.1296 107.924 57.5828 108.833 58.0912 109.728C58.1936 109.908 58.4227 109.971 58.603 109.869C58.7833 109.766 58.8463 109.537 58.7438 109.357Z",
    fill: "#406FBF"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 196.82H179.996V189.027H141.999V196.82Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M179.997 196.657H158.002V195.547L167.045 195.332H158.002V194.012L179.255 193.682L158.002 193.087V192.231H179.997V193.592L178.555 194.094V195.952L163.216 196.237H178.555V196.657H179.997ZM158.002 192.048V190.655L175.823 190.151H158.002V189.028H174.709H179.997V191.504L158.002 192.048Z",
    fill: "#E0E1DE"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 196.657H141.999V189.028H158.002V190.151H141.999V191.108L158.002 190.655V192.048L150.676 192.231H158.002V193.087L143.547 193.682L158.002 194.012V195.332H141.999V195.926L158.002 195.547V196.657Z",
    fill: "#C5C6C5"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 190.654V190.151H175.823L158.002 190.654Z",
    fill: "#C5C6C5"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 191.108V190.151H158.002V190.655L141.999 191.108Z",
    fill: "#ADB0AE"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M179.997 192.23H158.002V192.048L179.997 191.504V192.23Z",
    fill: "#C5C6C5"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M158.001 192.23H150.676L158.001 192.048V192.23Z",
    fill: "#ADB0AE"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 194.013V193.088L179.255 193.682L158.002 194.013Z",
    fill: "#C5C6C5"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 194.013L143.548 193.682L158.002 193.088V194.013Z",
    fill: "#ADB0AE"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 195.547V195.332H167.045L158.002 195.547Z",
    fill: "#C5C6C5"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 195.926V195.331H158.002V195.546L141.999 195.926Z",
    fill: "#ADB0AE"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M178.555 196.236H163.216L178.555 195.952V196.236Z",
    fill: "#C5C6C5"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M136.709 189.028H174.708V181.235H136.709V189.028Z",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M174.709 189.028H152.714V187.753L161.756 187.539H152.714V186.219L173.967 185.889L152.714 185.295V184.437H174.709V188.443L174.654 188.133L157.928 188.443H174.709V189.028ZM152.714 184.255V182.862L170.534 182.357H152.714V181.235H157.052H174.709V183.711L152.714 184.255Z",
    fill: "#E0E1DE"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M152.713 189.028H136.709V181.235H152.713V182.357H136.709V183.314L152.713 182.862V184.255L145.387 184.437H152.713V185.295L138.258 185.889L152.713 186.219V187.539H136.709V188.133L152.713 187.753V189.028Z",
    fill: "#C5C6C5"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M152.714 182.861V182.357H170.534L152.714 182.861Z",
    fill: "#C5C6C5"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M136.709 183.314V182.357H152.713V182.862L136.709 183.314Z",
    fill: "#ADB0AE"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M174.709 184.437H152.714V184.254L174.709 183.71V184.437Z",
    fill: "#C5C6C5"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M152.714 184.437H145.388L152.714 184.254V184.437Z",
    fill: "#ADB0AE"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M152.714 186.219V185.295L173.967 185.888L152.714 186.219Z",
    fill: "#C5C6C5"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M152.715 186.219L138.26 185.888L152.715 185.295V186.219Z",
    fill: "#ADB0AE"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M152.714 187.752V187.538H161.756L152.714 187.752Z",
    fill: "#C5C6C5"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M136.709 188.134V187.539H152.713V187.753L136.709 188.134Z",
    fill: "#ADB0AE"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M174.709 188.442H157.928L174.654 188.133L174.709 188.442Z",
    fill: "#C5C6C5"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M141.049 181.235H179.048V173.442H141.049V181.235Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M179.048 181.235H157.053V179.96L166.095 179.746H157.053V178.426L170.679 178.214C171.2 178.476 171.779 178.626 172.38 178.626H179.048V180.65L178.993 180.34L162.267 180.65H179.048V181.235ZM141.049 181.235V173.442H168.337L168.441 174.564H157.053V173.442H141.049V181.235ZM170.113 177.867L157.053 177.502V176.644H169.003C169.286 177.122 169.666 177.54 170.113 177.867ZM157.053 176.462V175.069L168.457 174.747L168.486 175.051C168.521 175.442 168.618 175.82 168.767 176.172L157.053 176.462Z",
    fill: "#E0E1DE"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M157.053 181.235H141.049V173.442H157.053V174.564H141.049V175.521L157.053 175.069V176.462L149.726 176.644H157.053V177.502L142.599 178.096L157.053 178.426V179.746H141.049V180.34L157.053 179.96V181.235Z",
    fill: "#C5C6C5"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M157.052 175.067V174.563H168.44L168.456 174.745L157.052 175.067Z",
    fill: "#C5C6C5"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M141.049 175.521V174.564H157.053V175.068L141.049 175.521Z",
    fill: "#ADB0AE"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M169.003 176.643H157.052V176.461L168.767 176.171C168.835 176.334 168.914 176.491 169.003 176.643Z",
    fill: "#C5C6C5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M157.053 176.643H149.726L157.053 176.461V176.643Z",
    fill: "#ADB0AE"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M157.052 178.425V177.501L170.112 177.865C170.291 177.996 170.48 178.112 170.679 178.213L157.052 178.425Z",
    fill: "#C5C6C5"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M157.053 178.425L142.598 178.094L157.053 177.501V178.425Z",
    fill: "#ADB0AE"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M157.052 179.959V179.745H166.095L157.052 179.959Z",
    fill: "#C5C6C5"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M141.049 180.34V179.745H157.053V179.959L141.049 180.34Z",
    fill: "#ADB0AE"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M179.047 180.649H162.267L178.992 180.34L179.047 180.649Z",
    fill: "#C5C6C5"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M204.36 196.657L205.348 192.925H245.943L264.635 194.791L265.347 196.657H204.36Z",
    fill: "#17282F"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M245.944 196.657H221.401V194.094L213.622 192.925H245.944V196.657Z",
    fill: "#0C1418"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M237.789 175.05C237.969 177.022 236.527 178.625 234.565 178.625H172.38C170.408 178.625 168.666 177.022 168.486 175.05L164.792 135.238C164.752 134.828 164.781 134.439 164.873 134.077C165.222 132.676 166.453 131.666 168.015 131.666H230.201C232.173 131.666 233.914 133.266 234.095 135.238L237.789 175.05Z",
    fill: "#17282F"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M234.345 178.625H202.213L204.486 154.206H191.622L188.778 178.625H172.38C171.779 178.625 171.199 178.476 170.679 178.214C170.481 178.113 170.291 177.997 170.112 177.866C169.218 177.212 168.59 176.193 168.486 175.05L168.457 174.746L168.441 174.564L164.792 135.238C164.78 135.117 164.774 134.997 164.774 134.879C164.775 134.6 164.808 134.332 164.872 134.077H226.837C228.799 134.077 230.54 135.679 230.73 137.652L234.425 177.464C234.465 177.874 234.435 178.264 234.345 178.625Z",
    fill: "#0C1418"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M191.622 154.207H204.487L201.058 191.038L221.401 194.094V196.657H178.556V194.094L187.333 191.038L191.622 154.207Z",
    fill: "#17282F"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M194.956 196.073L187.333 195.846L191.623 154.206H204.487L194.956 196.073Z",
    fill: "#2B3C43"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M204.427 357.235H198.294L187.277 203.828H195.412L204.427 357.235Z",
    fill: "#17282F"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M197.452 345.49L196.733 335.5H196.735L197.453 345.49H197.452ZM196.717 335.25H196.715L195.819 322.775H195.821L196.717 335.25ZM195.803 322.525H195.801L192.59 277.879H192.596L195.803 322.525ZM192.578 277.629H192.572L187.814 211.447L187.537 207.669H187.551L187.581 208.062L192.578 277.629Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M195.82 322.775H195.818L195.8 322.525H195.802L195.82 322.775Z",
    fill: "#F0F0EE"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M196.735 335.501H196.733L196.715 335.251H196.717L196.735 335.501Z",
    fill: "#F0F0EE"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M192.596 277.879H192.59L192.572 277.629H192.578L192.596 277.879Z",
    fill: "#F0F0EE"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M203.732 345.394L203.15 335.501H203.153L203.735 345.394H203.732ZM203.138 335.251H203.136L202.402 322.776H202.404L203.138 335.251ZM202.389 322.526H202.388L201.46 306.734L202.389 322.526Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M202.405 322.775H202.403L202.389 322.525H202.39L202.405 322.775Z",
    fill: "#F0F0EE"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M203.153 335.501H203.15L203.136 335.251H203.138L203.153 335.501Z",
    fill: "#F0F0EE"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M204.432 357.235H198.296L197.452 345.49H197.453L198.296 357.235H204.428L203.732 345.393H203.735L204.432 357.235Z",
    fill: "#F9F9F8"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M204.428 357.235H198.296L197.453 345.49L196.735 335.5L196.717 335.25L195.821 322.775L195.803 322.525L192.597 277.879L192.579 277.629L187.581 208.062L187.815 211.082H195.832L195.853 211.447L201.461 306.734L202.389 322.525L202.403 322.775L203.137 335.25L203.151 335.5L203.732 345.393L204.428 357.235Z",
    fill: "#6C7A7F"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M195.852 211.082H195.838L195.638 207.668L195.852 211.082Z",
    fill: "#C3C5C2"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M195.838 211.082H195.831L195.627 207.668H195.638L195.838 211.082Z",
    fill: "#111D23"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M187.581 208.062L187.551 207.668H187.553L187.581 208.062Z",
    fill: "#C3C4C2"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M195.831 211.082H187.814L187.58 208.062L187.552 207.668H195.627L195.831 211.082Z",
    fill: "#535F64"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M249.433 357.235H243.301L242.3 203.828H250.435L249.433 357.235Z",
    fill: "#17282F"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M249.514 345.064L249.659 322.775H249.665L249.519 345.064H249.514ZM249.666 322.525H249.661L249.78 304.201L249.786 304.195L249.666 322.525Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M249.665 322.775H249.659L249.661 322.525H249.666L249.665 322.775Z",
    fill: "#F3F2F1"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M249.798 302.405L249.792 302.403L249.81 299.727C249.812 299.722 249.814 299.718 249.816 299.713L249.798 302.405Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M250.166 245.123L250.27 229.101H250.277L250.173 245.1C250.171 245.107 250.168 245.117 250.166 245.123Z",
    fill: "#F0F0EE"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M249.438 357.235H243.302H249.433L249.513 345.065H249.518L249.438 357.235Z",
    fill: "#FAFAF9"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M249.81 299.727L250.166 245.122C250.168 245.116 250.171 245.106 250.173 245.099L249.815 299.712C249.813 299.717 249.812 299.721 249.81 299.727Z",
    fill: "#CFE0F5"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M249.78 304.201L249.792 302.402L249.798 302.404L249.786 304.195L249.78 304.201Z",
    fill: "#90B4E3"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M242.766 275.253H242.765L242.754 273.566H242.755L242.766 275.253ZM242.738 271.07L242.727 269.382L242.738 271.07ZM242.711 266.887H242.71L242.699 265.199H242.7L242.711 266.887ZM242.684 262.704H242.683L242.672 261.016H242.673L242.684 262.704ZM242.657 258.52H242.656L242.645 256.832H242.646L242.657 258.52ZM242.629 254.337H242.628L242.617 252.648H242.618L242.629 254.337ZM242.602 250.154H242.601L242.463 229.101H242.465L242.602 250.154Z",
    fill: "#F0F0EE"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M242.619 252.648H242.618L242.602 250.154H242.603L242.619 252.648Z",
    fill: "#F7F7F6"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M242.646 256.832H242.645L242.628 254.337H242.629L242.646 256.832Z",
    fill: "#F7F7F6"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M242.674 261.016H242.673L242.656 258.519H242.657L242.674 261.016Z",
    fill: "#F7F7F6"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M242.7 265.198H242.699L242.683 262.704H242.684L242.7 265.198Z",
    fill: "#F7F7F6"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M242.727 269.382L242.71 266.887H242.711L242.727 269.382Z",
    fill: "#F7F7F6"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 273.566H242.755L242.739 271.07L242.756 273.566Z",
    fill: "#F7F7F6"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M242.769 275.857L242.765 275.252H242.766L242.77 275.854L242.769 275.857Z",
    fill: "#F7F7F6"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M242.929 300.069H242.928L242.77 275.858L242.771 275.855L242.929 300.069Z",
    fill: "#CFE0F5"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M242.957 304.462L242.928 300.069H242.929L242.957 304.462Z",
    fill: "#90B4E3"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M249.433 357.235H243.302L242.957 304.462L242.929 300.07L242.77 275.855L242.766 275.253L242.755 273.567L242.738 271.07L242.727 269.382L242.711 266.888L242.7 265.199L242.684 262.704L242.673 261.017L242.657 258.52L242.646 256.832L242.629 254.338L242.618 252.649L242.602 250.154L242.465 229.101H250.27L250.166 245.123L249.81 299.727L249.792 302.403L249.78 304.202L249.661 322.525L249.659 322.775L249.513 345.065L249.433 357.235Z",
    fill: "#849193"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M250.279 229.101H250.277L250.279 228.824L250.416 207.668L250.279 229.101ZM242.463 229.101H242.462L242.324 207.668H242.325L242.462 228.824L242.463 229.101Z",
    fill: "#ACAFAD"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M250.278 229.101H250.271L250.411 207.668H250.417L250.28 228.824L250.278 229.101ZM242.465 229.101H242.463L242.462 228.824L242.325 207.668L242.465 229.101Z",
    fill: "#B8BAB8"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M250.271 229.101H242.465L242.325 207.668H250.411L250.271 229.101Z",
    fill: "#656F74"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M314.543 357.235H308.411L297.393 203.828H305.528L314.543 357.235Z",
    fill: "#17282F"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M313.868 345.688H313.864L313.788 344.389H313.791L313.868 345.688ZM307.573 345.567H307.572L307.488 344.389H307.489L307.573 345.567ZM306.687 333.248L305.934 322.776H305.936L306.688 333.248H306.687ZM305.918 322.525H305.916L303.635 290.808H303.64L305.918 322.525Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M305.936 322.775H305.934L305.916 322.525H305.918L305.936 322.775Z",
    fill: "#F3F2F1"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M303.64 290.808H303.636L303.343 286.73H303.348L303.64 290.808Z",
    fill: "#EDEDEB"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M303.347 286.729H303.342L301.985 267.849H301.991L303.347 286.729Z",
    fill: "#F0F0EE"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M313.096 332.618L312.517 322.775H312.519L313.098 332.618H313.096ZM312.504 322.525H312.503L311.576 306.761L312.504 322.525Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M312.52 322.775H312.518L312.504 322.525H312.505L312.52 322.775Z",
    fill: "#F3F2F1"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M298.723 222.354C298.72 222.353 298.717 222.352 298.713 222.352L297.929 211.447L297.652 207.669H297.666L297.696 208.053L298.723 222.354Z",
    fill: "#F0F0EE"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M314.547 357.235H308.41L307.572 345.567H307.573L308.41 357.235H314.543L313.864 345.687H313.868L314.547 357.235Z",
    fill: "#FAFAF9"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M313.791 344.389H313.788L313.096 332.618H313.098L313.791 344.389ZM307.488 344.389H307.487L306.686 333.248H306.687L307.488 344.389Z",
    fill: "#9BA6A8"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M301.57 262H301.564L301.243 257.531C301.246 257.532 301.247 257.532 301.25 257.532L301.57 262Z",
    fill: "#849193"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M301.991 267.851H301.985L301.565 262H301.571L301.991 267.851Z",
    fill: "#CCD1CF"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M300.872 252.275C300.869 252.274 300.867 252.273 300.864 252.272L298.713 222.351C298.717 222.351 298.72 222.352 298.723 222.353L300.872 252.275Z",
    fill: "#CFE0F5"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M301.25 257.531C301.247 257.531 301.246 257.531 301.243 257.53L300.865 252.272C300.868 252.273 300.87 252.274 300.873 252.275L301.25 257.531Z",
    fill: "#C5D5F0"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M314.543 357.235H308.411L307.573 345.567L307.489 344.389L306.688 333.248L305.936 322.775L305.918 322.525L303.64 290.808L303.347 286.731L301.991 267.851L301.571 262L301.25 257.532L300.873 252.275L298.724 222.353L297.697 208.052L297.93 211.082H305.947L305.968 211.447L311.577 306.761L312.504 322.525L312.518 322.775L313.097 332.619L313.788 344.389L313.864 345.687L314.543 357.235Z",
    fill: "#849193"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M305.967 211.082H305.953L305.817 208.759L305.825 208.809L305.967 211.082Z",
    fill: "#ACAFAD"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M305.826 208.809L305.818 208.759L305.768 207.902H305.769L305.826 208.809Z",
    fill: "#0C161A"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M305.768 207.902L305.754 207.669L305.769 207.902H305.768Z",
    fill: "#3563B7"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M305.954 211.082H305.947L305.742 207.668H305.753L305.767 207.902L305.818 208.759L305.954 211.082Z",
    fill: "#111D23"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M297.696 208.052L297.666 207.668H297.668L297.696 208.052Z",
    fill: "#B8BAB8"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M305.947 211.082H297.93L297.696 208.052L297.668 207.668H305.743L305.947 211.082Z",
    fill: "#656F74"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M134.272 357.235H128.14L137.155 203.828H145.291L134.272 357.235Z",
    fill: "#17282F"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M138.57 297.389L139.972 277.879H139.973L138.57 297.389ZM139.991 277.629H139.99L145.015 207.669H145.026L144.749 211.447L139.991 277.629Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M139.973 277.879H139.972L139.99 277.629H139.991L139.973 277.879Z",
    fill: "#F3F2F1"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M134.268 357.235H128.141L136.71 211.447L136.732 211.082H144.749L145.012 207.669H145.015L139.99 277.629L139.972 277.879L138.57 297.389L134.268 357.235Z",
    fill: "#849193"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M136.727 211.082H136.709L136.925 207.668H136.929L136.727 211.082Z",
    fill: "#C3C5C2"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M136.732 211.082H136.728L136.929 207.668H136.936L136.732 211.082Z",
    fill: "#111D23"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M144.749 211.082H136.733L136.937 207.668H145.013L144.749 211.082Z",
    fill: "#656F74"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M309.813 207.669H132.871C131.675 207.669 130.706 206.701 130.706 205.505V199.986H311.977V205.505C311.977 206.701 311.008 207.669 309.813 207.669Z",
    fill: "#406FBF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M309.813 207.669H132.871C131.675 207.669 130.706 206.701 130.706 205.505V200.988V203.828H311.977V205.505C311.977 206.701 311.008 207.669 309.813 207.669Z",
    fill: "#A4C3E9"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M130.706 203.827H311.977V200.987H130.706V203.827Z",
    fill: "#7F9BCF"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M315.779 200.987H126.905C125.71 200.987 124.74 200.017 124.74 198.823C124.74 197.627 125.71 196.657 126.905 196.657H315.779C316.975 196.657 317.943 197.627 317.943 198.823C317.943 200.017 316.975 200.987 315.779 200.987Z",
    fill: "#406FBF"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M315.779 200.987H126.905C125.71 200.987 124.74 200.017 124.74 198.823C124.74 197.627 125.71 196.657 126.905 196.657H267.409H286.539H299.863H315.779C316.975 196.657 317.943 197.627 317.943 198.823C317.943 200.017 316.975 200.987 315.779 200.987Z",
    fill: "#A4C3E9"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M271.091 189.991L273.417 186.508C273.881 185.813 274.66 185.396 275.496 185.396H278.442C278.688 185.396 278.933 185.433 279.167 185.504L289.666 188.686C290.264 188.867 290.771 189.265 291.091 189.801L292.596 192.333L271.091 189.991Z",
    fill: "#406FBF"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M272.451 187.955L273.415 186.508C273.875 185.817 274.657 185.395 275.497 185.395H276.819V185.396H275.496C274.66 185.396 273.88 185.814 273.417 186.509L272.451 187.955Z",
    fill: "#BABCBA"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M278.706 185.409C278.618 185.4 278.53 185.395 278.442 185.395H276.82V185.394H278.44C278.53 185.394 278.618 185.4 278.706 185.409Z",
    fill: "#ACAFAD"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M271.723 189.046L272.45 187.955L273.416 186.508C273.88 185.814 274.66 185.396 275.496 185.396H276.819H278.442C278.53 185.396 278.618 185.401 278.705 185.41C278.862 185.428 279.016 185.461 279.17 185.506L279.401 185.576L289.661 188.69C289.897 188.76 290.117 188.863 290.318 188.993C290.117 188.863 289.897 188.76 289.661 188.69L279.401 185.576L278.008 188.97H272.504C272.238 188.97 271.976 188.996 271.723 189.046Z",
    fill: "#3563B7"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M291.444 190.391L291.439 190.389L291.091 189.802C290.896 189.475 290.631 189.199 290.319 188.993C290.633 189.197 290.9 189.472 291.095 189.801L291.444 190.391Z",
    fill: "#858889"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M291.438 190.389L290.102 189.891L288.3 189.22C287.85 189.05 287.38 188.97 286.9 188.97H278.008L279.401 185.577L289.662 188.69C289.897 188.76 290.117 188.863 290.318 188.993C290.631 189.199 290.895 189.475 291.09 189.802L291.438 190.389Z",
    fill: "#2555AD"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M299.863 196.328V196.657H267.409L268.611 191.963C269.08 190.201 270.682 188.97 272.505 188.97H286.9C287.381 188.97 287.85 189.05 288.301 189.22L290.102 189.891L297.25 192.554C298.822 193.145 299.863 194.646 299.863 196.328Z",
    fill: "#406FBF"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M299.862 196.657H286.538L287.25 191.583C287.403 190.501 288.338 189.757 289.361 189.757C289.607 189.757 289.857 189.8 290.102 189.891L297.25 192.554C298.821 193.145 299.862 194.646 299.862 196.328V196.657Z",
    fill: "#3563B7"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M288.615 193.207L292.852 180.486C293.036 179.937 293.666 179.681 294.181 179.946C294.572 180.149 294.771 180.597 294.659 181.024L291.089 194.605C291.089 194.605 288.713 195.566 288.615 193.207Z",
    fill: "#17282F"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M271.091 195.601H269.21L269.572 193.753H271.453L271.091 195.601Z",
    fill: "#3563B7"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M273.895 195.53H272.014L272.377 193.682H274.259L273.895 195.53Z",
    fill: "#3563B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsImg);
export default __webpack_public_path__ + "static/media/contact_us_img.00275f7f6d20d75c12b60bcf59a0a0c6.svg";
export { ForwardRef as ReactComponent };